import React from 'react'
import Nav from './Navigation/Nav.js'
import Testing from './Testing.js'

const App = () => {
  return (
   <Nav/>
  )
}

export default App
// --------------------------------------------------------------------------------------------------------------------------
// import React, { useState, useEffect } from 'react';

// export default function ExperimentalUniverse() {
//   const [currentTime, setCurrentTime] = useState('');
//   const [selectedPhoto, setSelectedPhoto] = useState(null);

//   // Update clock live for the dashboard vibe
//   useEffect(() => {
//     const updateTime = () => {
//       const now = new Date();
//       setCurrentTime(now.toTimeString().split(' ')[0]);
//     };
//     updateTime();
//     const interval = setInterval(updateTime, 1000);
//     return () => clearInterval(interval);
//   }, []);

//   // Global CSS overrides for animations & immersive hover effects
//   const structuralStyles = `
//     @keyframes floatingGlow {
//       0% { transform: translate(0px, 0px) scale(1); }
//       33% { transform: translate(40px, -60px) scale(1.15); }
//       66% { transform: translate(-30px, 30px) scale(0.9); }
//       100% { transform: translate(0px, 0px) scale(1); }
//     }
//     @keyframes marquee {
//       0% { transform: translateX(0%); }
//       100% { transform: translateX(-50%); }
//     }
//     .grid-cell {
//       transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
//     }
//     .grid-cell:hover {
//       transform: translateY(-8px) scale(1.01);
//       box-shadow: 0 30px 60px rgba(0,0,0,0.8), 0 0 30px rgba(0, 255, 163, 0.15);
//       border-color: #00ffa3 !important;
//     }
//     .social-tag {
//       transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
//     }
//     .social-tag:hover {
//       background: #ffffff !important;
//       color: #050508 !important;
//       transform: scale(1.05) translateY(-2px);
//       box-shadow: 0 10px 20px rgba(255,255,255,0.1);
//     }
//     .snapchat-tag:hover {
//       background: #FFFC00 !important;
//       color: #000000 !important;
//       border-color: #FFFC00 !important;
//       box-shadow: 0 10px 20px rgba(255, 252, 0, 0.2);
//     }
//     .photo-frame {
//       transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
//       cursor: zoom-in;
//     }
//     .photo-frame:hover {
//       transform: scale(1.1) rotate(3deg);
//       z-index: 10;
//       box-shadow: 0 20px 40px rgba(0,0,0,0.6);
//       border-color: #00ffa3 !important;
//     }
//   `;

//   const theme = {
//     bg: '#050508',
//     cardBg: 'rgba(15, 15, 25, 0.65)',
//     border: 'rgba(255, 255, 255, 0.06)',
//     accentCyan: '#00ffa3',
//     accentPink: '#ff0055',
//     accentNeon: '#9d00ff',
//     textMain: '#ffffff',
//     textMuted: '#6c6c8a'
//   };

//   const styles = {
//     container: {
//       backgroundColor: theme.bg,
//       color: theme.textMain,
//       fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//       minHeight: '100vh',
//       padding: '40px 20px',
//       position: 'relative',
//       overflowX: 'hidden',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//       alignItems: 'center'
//     },
//     bgOrbs: {
//       position: 'absolute',
//       width: '600px',
//       height: '600px',
//       background: `radial-gradient(circle, rgba(0,255,163,0.06) 0%, rgba(157,0,255,0.03) 50%, rgba(0,0,0,0) 70%)`,
//       top: '-10%',
//       left: '-10%',
//       animation: 'floatingGlow 12s infinite ease-in-out',
//       pointerEvents: 'none'
//     },
//     bgOrbs2: {
//       position: 'absolute',
//       width: '500px',
//       height: '500px',
//       background: `radial-gradient(circle, rgba(255,0,85,0.05) 0%, rgba(0,0,0,0) 70%)`,
//       bottom: '10%',
//       right: '-5%',
//       animation: 'floatingGlow 16s infinite ease-in-out alternate',
//       pointerEvents: 'none'
//     },
//     bentoWrapper: {
//       width: '100%',
//       maxWidth: '1200px',
//       display: 'grid',
//       gridTemplateColumns: 'repeat(12, 1fr)',
//       gridAutoRows: 'minmax(140px, auto)',
//       gap: '20px',
//       position: 'relative',
//       zIndex: 5
//     },
//     cell: (colSpan, rowSpan, customBg = theme.cardBg) => ({
//       gridColumn: `span ${colSpan}`,
//       gridRow: `span ${rowSpan}`,
//       backgroundColor: customBg,
//       backdropFilter: 'blur(25px)',
//       borderRadius: '32px',
//       border: `1px solid ${theme.border}`,
//       padding: '30px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       position: 'relative',
//       overflow: 'hidden'
//     }),
//     marqueeContainer: {
//       overflow: 'hidden',
//       whiteSpace: 'nowrap',
//       width: '100%',
//       display: 'flex',
//       position: 'relative'
//     },
//     marqueeTrack: {
//       display: 'flex',
//       animation: 'marquee 15s linear infinite',
//       fontSize: '4.5rem',
//       fontWeight: '900',
//       letterSpacing: '-2px',
//       textTransform: 'uppercase',
//       color: 'rgba(255,255,255,0.03)',
//       WebkitTextStroke: '1px rgba(255,255,255,0.08)'
//     },
//     avatar: {
//       width: '110px',
//       height: '110px',
//       borderRadius: '28px',
//       objectFit: 'cover',
//       border: `2px solid ${theme.accentCyan}`,
//       boxShadow: `0 0 20px rgba(0, 255, 163, 0.3)`
//     },
//     socialGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
//       gap: '12px',
//       width: '100%',
//       marginTop: '15px'
//     },
//     socialBadge: {
//       padding: '14px',
//       borderRadius: '16px',
//       backgroundColor: 'rgba(255,255,255,0.02)',
//       border: `1px solid ${theme.border}`,
//       color: theme.textMain,
//       textDecoration: 'none',
//       fontSize: '0.85rem',
//       fontWeight: '600',
//       textAlign: 'center',
//       display: 'block'
//     },
//     albumGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
//       gap: '12px',
//       width: '100%',
//       marginTop: '15px'
//     },
//     albumImage: {
//       width: '100%',
//       height: '130px',
//       objectFit: 'cover',
//       borderRadius: '16px',
//       border: `1px solid ${theme.border}`
//     },
//     iconWrap: (bg) => ({
//       width: '50px',
//       height: '50px',
//       borderRadius: '16px',
//       backgroundColor: bg,
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       marginBottom: '15px'
//     }),
//     connectLink: {
//       color: theme.textMain,
//       fontSize: '1.4rem',
//       fontWeight: '700',
//       textDecoration: 'none',
//       margin: '5px 0',
//       display: 'inline-block'
//     },
//     modal: {
//       position: 'fixed',
//       inset: 0,
//       backgroundColor: 'rgba(5, 5, 8, 0.95)',
//       backdropFilter: 'blur(15px)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: 100,
//       cursor: 'zoom-out'
//     }
//   };

//   const photoGallery = [
//     { id: 1, url: "https://unsplash.com", title: "Conceptual Art" },
//     { id: 2, url: "https://unsplash.com", title: "Visual Scenery" },
//     { id: 3, url: "https://unsplash.com", title: "Digital Setup" },
//     { id: 4, url: "https://unsplash.com", title: "Atmospheric Layers" },
//     { id: 5, url: "https://unsplash.com", title: "Code Spaces" },
//     { id: 6, url: "https://unsplash.com", title: "Hardware Matrix" }
//   ];

//   return (
//     <div style={styles.container}>
//       <style>{structuralStyles}</style>
//       <div style={styles.bgOrbs} />
//       <div style={styles.bgOrbs2} />

//       {/* Lightbox Modal Engine for Gallery Images */}
//       {selectedPhoto && (
//         <div style={styles.modal} onClick={() => setSelectedPhoto(null)}>
//           <img 
//             src={selectedPhoto} 
//             alt="Enlarged gallery view" 
//             style={{ maxWidth: '90%', maxHeight: '85%', borderRadius: '24px', boxShadow: '0 30px 60px rgba(0,0,0,0.8)', border: `1px solid ${theme.border}` }} 
//           />
//           <div style={{ position: 'absolute', bottom: '30px', color: theme.textMuted, fontSize: '0.9rem', letterSpacing: '1px' }}>
//             CLICK ANYWHERE TO EXIT VIEW
//           </div>
//         </div>
//       )}

//       <div style={styles.bentoWrapper}>

//         {/* Cell 1: Header Marquee Kinetic Loop */}
//         <div style={{...styles.cell(12, 1, 'transparent'), padding: '0', border: 'none', justifyContent: 'center'}}>
//           <div style={styles.marqueeContainer}>
//             <div style={styles.marqueeTrack}>
//               ASHISH MORE • DIGITAL PROFILE LAYER • SEAMLESS CONNECTIVITY • INSTAGRAM • SNAPCHAT • FACEBOOK • GITHUB • PINTEREST • TWITTER • 
//             </div>
//           </div>
//         </div>

//         {/* Cell 2: Primary Dynamic Personal Identity */}
//         <div style={styles.cell(5, 3)} className="grid-cell">
//           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <img 
//               src="https://unsplash.com" 
//               alt="Ashish More" 
//               style={styles.avatar} 
//             />
//             <div style={{ textAlign: 'right', fontSize: '0.8rem', color: theme.accentCyan, fontWeight: '700', letterSpacing: '2px' }}>
//               LIVE METADATA<br />
//               <span style={{ color: theme.textMain, fontFamily: 'monospace', fontSize: '1.1rem' }}>{currentTime}</span>
//             </div>
//           </div>
//           <div style={{ marginTop: '30px' }}>
//             <h1 style={{ fontSize: '3rem', fontWeight: '900', margin: '0 0 10px 0', letterSpacing: '-1px', lineHeight: '1' }}>Ashish More</h1>
//             <p style={{ color: theme.textMuted, margin: 0, fontSize: '1.02rem', lineHeight: '1.6' }}>
//               Digital Curator exploring interactive spatial configurations, personal network nodes, and high-fidelity media frameworks.
//             </p>
//           </div>
//         </div>

//         {/* Cell 3: Expanded Responsive Grid Photo Gallery */}
//         <div style={styles.cell(7, 3)} className="grid-cell">
//           <div>
//             <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', color: theme.accentPink }}>VISUAL TIMELINE // MATRIX ALBUM</span>
//             <h2 style={{ fontSize: '1.6rem', margin: '5px 0 15px 0', fontWeight: '800' }}>Photo Vault Gallery</h2>
//           </div>
//           <div style={styles.albumGrid}>
//             {photoGallery.map((img) => (
//               <img 
//                 key={img.id}
//                 src={img.url} 
//                 alt={img.title} 
//                 style={styles.albumImage} 
//                 className="photo-frame" 
//                 onClick={() => setSelectedPhoto(img.url)}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Cell 4: Communications Endpoint Connections */}
//         <div style={styles.cell(4, 2)} className="grid-cell">
//           <div>
//             <div style={styles.iconWrap('rgba(0, 255, 163, 0.1)')}>
//               <span style={{ color: theme.accentCyan, fontSize: '1.5rem' }}>✉</span>
//             </div>
//             <span style={{ fontSize: '0.75rem', fontWeight: '700', color: theme.textMuted }}>SECURE EMAIL DIRECT</span>
//             <br />
//             <a href="mailto:hello@ashishmore.com" style={styles.connectLink}>hello@ashishmore.com</a>
//           </div>
//           <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: '15px' }}>
//             <span style={{ fontSize: '0.75rem', fontWeight: '700', color: theme.textMuted }}>TELEPHONIC CALL endpoint</span>
//             <br />
//             <a href="tel:+919876543210" style={{ ...styles.connectLink, fontSize: '1.2rem', color: theme.accentCyan }}>+91 98765 43210</a>
//           </div>
//         </div>

//         {/* Cell 5: Comprehensive Interactive Social Hub */}
//         <div style={styles.cell(5, 2)} className="grid-cell">
//           <div>
//             <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', color: theme.accentNeon }}>ROUTING ENDPOINTS</span>
//             <h3 style={{ fontSize: '1.4rem', margin: '5px 0 0 0', fontWeight: '800' }}>Social Architecture</h3>
//           </div>
//           <div style={styles.socialGrid}>
//             <a href="https://snapchat.com" target="_blank" rel="noreferrer" style={styles.socialBadge} className="social-tag snapchat-tag">Snapchat</a>
//             <a href="https://instagram.com" target="_blank" rel="noreferrer" style={styles.socialBadge} className="social-tag">Instagram</a>
//             <a href="https://facebook.com" target="_blank" rel="noreferrer" style={styles.socialBadge} className="social-tag">Facebook</a>
//             <a href="https://twitter.com" target="_blank" rel="noreferrer" style={styles.socialBadge} className="social-tag">Twitter</a>
//             <a href="https://github.com" target="_blank" rel="noreferrer" style={styles.socialBadge} className="social-tag">GitHub</a>
//             <a href="https://pinterest.com" target="_blank" rel="noreferrer" style={styles.socialBadge} className="social-tag">Pinterest</a>
//           </div>
//         </div>

//         {/* Cell 6: Curated Audio Engine Block */}
//         <div style={{...styles.cell(3, 2), backgroundColor: '#091c13', borderColor: 'rgba(30,215,96,0.15)'}} className="grid-cell">
//           <div>
//             <div style={styles.iconWrap('rgba(30, 215, 96, 0.15)')}>
//               <span style={{ color: '#1ed760', fontSize: '1.5rem', fontWeight: 'bold' }}>♫</span>
//             </div>
//             <span style={{ fontSize: '0.75rem', fontWeight: '800', color: '#1ed760', letterSpacing: '1px' }}>SOUND TRANSMISSION</span>
//             <h4 style={{ fontSize: '1.2rem', margin: '8px 0 4px 0', fontWeight: '800' }}>Midnight Wave</h4>
//             <p style={{ color: '#88a695', fontSize: '0.85rem', margin: 0 }}>Curating Digital Audio Ambient Spaces</p>
//           </div>
//           <a href="https://spotify.com" target="_blank" rel="noreferrer" style={{ color: '#1ed760', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px' }}>
//             Connect Spotify Layer ↗
//           </a>
//         </div>

//       </div>
//     </div>
//   );
// }
// ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

// import React, { useState, useEffect } from 'react';

// export default function PremiumPastelPortfolio() {
//   const [currentTime, setCurrentTime] = useState('');
//   const [selectedPhoto, setSelectedPhoto] = useState(null);
//   const [activeTab, setActiveTab] = useState('home');

//   useEffect(() => {
//     const updateTime = () => {
//       const now = new Date();
//       setCurrentTime(now.toTimeString().split(' ')[0]);
//     };
//     updateTime();
//     const interval = setInterval(updateTime, 1000);
//     return () => clearInterval(interval);
//   }, []);

//   // Immersive structural animations & custom dynamic hover styles
//   const structuralStyles = `
//     @keyframes floatingGlow {
//       0% { transform: translate(0px, 0px) scale(1); }
//       33% { transform: translate(25px, -35px) scale(1.08); }
//       66% { transform: translate(-15px, 15px) scale(0.97); }
//       100% { transform: translate(0px, 0px) scale(1); }
//     }
//     @keyframes marquee {
//       0% { transform: translateX(0%); }
//       100% { transform: translateX(-50%); }
//     }
//     @keyframes fadeIn {
//       from { opacity: 0; transform: translateY(15px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     .grid-cell {
//       transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
//       animation: fadeIn 0.6s ease forwards;
//     }
//     .grid-cell:hover {
//       transform: translateY(-5px);
//       box-shadow: 0 20px 40px rgba(165, 180, 200, 0.2);
//     }
//     .nav-tab {
//       transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
//     }
//     .nav-tab:hover {
//       background-color: rgba(255, 255, 255, 0.9);
//       color: #1e222e !important;
//     }
//     .photo-frame {
//       transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
//       cursor: zoom-in;
//     }
//     .photo-frame:hover {
//       transform: scale(1.04) rotate(1deg);
//       z-index: 10;
//       box-shadow: 0 15px 30px rgba(100,100,120,0.1);
//     }

//     /* --- Dynamic Social Media OG Color Branded Hover Engines --- */
//     .social-badge {
//       padding: 14px;
//       borderRadius: 14px;
//       background-color: #ffffff;
//       border: 1px solid rgba(215, 220, 235, 0.5);
//       color: #1e222e;
//       text-decoration: none;
//       font-size: 0.85rem;
//       font-weight: 600;
//       text-align: center;
//       display: block;
//       box-shadow: 0 4px 10px rgba(160, 175, 195, 0.02);
//       transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
//     }

//     .snapchat-btn:hover {
//       background-color: #FFFC00 !important;
//       color: #000000 !important;
//       border-color: #e2df00 !important;
//       box-shadow: 0 10px 20px rgba(255, 252, 0, 0.35) !important;
//       transform: scale(1.04) translateY(-3px);
//     }
//     .instagram-btn:hover {
//       background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%) !important;
//       color: #ffffff !important;
//       border-color: #dc2743 !important;
//       box-shadow: 0 10px 20px rgba(220, 39, 67, 0.25) !important;
//       transform: scale(1.04) translateY(-3px);
//     }
//     .facebook-btn:hover {
//       background-color: #1877F2 !important;
//       color: #ffffff !important;
//       border-color: #1877F2 !important;
//       box-shadow: 0 10px 20px rgba(24, 119, 242, 0.25) !important;
//       transform: scale(1.04) translateY(-3px);
//     }
//     .twitter-btn:hover {
//       background-color: #000000 !important;
//       color: #ffffff !important;
//       border-color: #000000 !important;
//       box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2) !important;
//       transform: scale(1.04) translateY(-3px);
//     }
//     .github-btn:hover {
//       background-color: #24292e !important;
//       color: #ffffff !important;
//       border-color: #24292e !important;
//       box-shadow: 0 10px 20px rgba(36, 41, 46, 0.25) !important;
//       transform: scale(1.04) translateY(-3px);
//     }
//     .pinterest-btn:hover {
//       background-color: #E60023 !important;
//       color: #ffffff !important;
//       border-color: #E60023 !important;
//       box-shadow: 0 10px 20px rgba(230, 0, 35, 0.25) !important;
//       transform: scale(1.04) translateY(-3px);
//     }
//     .spotify-btn:hover {
//       background-color: #1ED760 !important;
//       color: #ffffff !important;
//       border-color: #1ED760 !important;
//       box-shadow: 0 10px 20px rgba(30, 215, 96, 0.3) !important;
//       transform: scale(1.04) translateY(-3px);
//     }
//   `;

//   const theme = {
//     bg: '#f6f8fa',              
//     cardBg: 'rgba(255, 255, 255, 0.8)', 
//     border: 'rgba(215, 220, 235, 0.5)',
//     accentMint: '#e8f7f2',      
//     accentRose: '#fdf0f3',      
//     accentLavender: '#eff2ff',  
//     textMain: '#1e222e',        
//     textMuted: '#6b758e'        
//   };

//   const styles = {
//     container: {
//       backgroundColor: theme.bg,
//       color: theme.textMain,
//       fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", Roboto, sans-serif',
//       minHeight: '100vh',
//       padding: '40px 20px',
//       position: 'relative',
//       overflowX: 'hidden',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'flex-start'
//     },
//     bgOrbs: {
//       position: 'absolute',
//       width: '700px',
//       height: '700px',
//       background: `radial-gradient(circle, rgba(239,242,255,0.9) 0%, rgba(246,248,250,0) 70%)`,
//       top: '-10%',
//       left: '-5%',
//       animation: 'floatingGlow 15s infinite ease-in-out',
//       pointerEvents: 'none',
//       zIndex: 1
//     },
//     bgOrbs2: {
//       position: 'absolute',
//       width: '600px',
//       height: '600px',
//       background: `radial-gradient(circle, rgba(253,240,243,0.8) 0%, rgba(246,248,250,0) 70%)`,
//       bottom: '5%',
//       right: '-5%',
//       animation: 'floatingGlow 20s infinite ease-in-out alternate',
//       pointerEvents: 'none',
//       zIndex: 1
//     },
//     tabBar: {
//       display: 'inline-flex',
//       backgroundColor: 'rgba(230, 235, 245, 0.6)',
//       backdropFilter: 'blur(20px)',
//       padding: '6px',
//       borderRadius: '20px',
//       gap: '4px',
//       marginBottom: '50px',
//       zIndex: 20,
//       border: '1px solid rgba(255, 255, 255, 0.6)',
//       boxShadow: '0 8px 24px rgba(160, 175, 195, 0.1)'
//     },
//     tabButton: (isActive) => ({
//       padding: '10px 24px',
//       borderRadius: '14px',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '0.9rem',
//       fontWeight: '600',
//       color: isActive ? '#ffffff' : theme.textMuted,
//       backgroundColor: isActive ? '#4f6ef2' : 'transparent', 
//       boxShadow: isActive ? '0 6px 14px rgba(79, 110, 242, 0.2)' : 'none',
//     }),
//     bentoWrapper: {
//       width: '100%',
//       maxWidth: '1100px',
//       display: 'grid',
//       gridTemplateColumns: 'repeat(12, 1fr)',
//       gridAutoRows: 'minmax(130px, auto)',
//       gap: '24px',
//       position: 'relative',
//       zIndex: 10
//     },
//     cell: (colSpan, rowSpan, customBg = theme.cardBg) => ({
//       gridColumn: `span ${colSpan}`,
//       gridRow: `span ${rowSpan}`,
//       backgroundColor: customBg,
//       backdropFilter: 'blur(30px)',
//       borderRadius: '32px',
//       border: `1px solid ${theme.border}`,
//       padding: '35px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       position: 'relative',
//       overflow: 'hidden',
//       boxShadow: '0 10px 30px rgba(160, 175, 195, 0.06)'
//     }),
//     marqueeContainer: {
//       overflow: 'hidden',
//       whiteSpace: 'nowrap',
//       width: '100%',
//       display: 'flex',
//       position: 'relative'
//     },
//     marqueeTrack: {
//       display: 'flex',
//       animation: 'marquee 25s linear infinite',
//       fontSize: '4.5rem',
//       fontWeight: '900',
//       letterSpacing: '-1px',
//       textTransform: 'uppercase',
//       color: 'rgba(30, 34, 46, 0.015)',
//       WebkitTextStroke: '1px rgba(30, 34, 46, 0.04)'
//     },
//     avatar: {
//       width: '130px',
//       height: '130px',
//       borderRadius: '40px',
//       objectFit: 'cover',
//       border: '4px solid #ffffff',
//       boxShadow: '0 10px 25px rgba(160, 175, 195, 0.15)'
//     },
//     socialGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
//       gap: '12px',
//       width: '100%',
//       marginTop: '15px',
//       borderRadius:'10%'
//     },
//     albumGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(3, 1fr)',
//       gap: '16px',
//       width: '100%',
//       marginTop: '15px'
//     },
//     albumImage: {
//       width: '100%',
//       height: '150px',
//       objectFit: 'cover',
//       borderRadius: '20px',
//       border: '2px solid #ffffff',
//       boxShadow: '0 6px 15px rgba(160, 175, 195, 0.08)'
//     },
//     iconWrap: (bg) => ({
//       width: '48px',
//       height: '48px',
//       borderRadius: '16px',
//       backgroundColor: bg,
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       marginBottom: '15px'
//     }),
//     connectLink: {
//       color: theme.textMain,
//       fontSize: '1.4rem',
//       fontWeight: '700',
//       textDecoration: 'none',
//       margin: '4px 0',
//       display: 'inline-block'
//     },
//     modal: {
//       position: 'fixed',
//       inset: 0,
//       backgroundColor: 'rgba(246, 248, 250, 0.96)',
//       backdropFilter: 'blur(20px)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: 100,
//       cursor: 'zoom-out'
//     }
//   };

//   const photoGallery = [
//     { id: 1, url: "https://unsplash.com", title: "Soft Abstract" },
//     { id: 2, url: "https://unsplash.com", title: "Flora Frame" },
//     { id: 3, url: "https://unsplash.com", title: "Pastel Sky" },
//     { id: 4, url: "https://unsplash.com", title: "Gradient Soft" },
//     { id: 5, url: "https://unsplash.com", title: "Artistic Vignette" },
//     { id: 6, url: "https://unsplash.com", title: "Fluid Lines" }
//   ];

//   return (
//     <div style={styles.container}>
//       <style>{structuralStyles}</style>
//       <div style={styles.bgOrbs} />
//       <div style={styles.bgOrbs2} />

//       {/* Fullscreen Lightbox Frame */}
//       {selectedPhoto && (
//         <div style={styles.modal} onClick={() => setSelectedPhoto(null)}>
//           <img 
//             src={selectedPhoto} 
//             alt="Expanded presentation portrait" 
//             style={{ maxWidth: '85%', maxHeight: '80%', borderRadius: '24px', boxShadow: '0 30px 60px rgba(130,145,170,0.15)', border: '6px solid #ffffff' }} 
//           />
//           <div style={{ position: 'absolute', bottom: '30px', color: theme.textMuted, fontSize: '0.85rem', fontWeight: '600', letterSpacing: '1px' }}>
//             CLICK ANYWHERE TO CLOSE
//           </div>
//         </div>
//       )}

//       {/* Navigation Layer */}
//       <nav style={styles.tabBar}>
//         <button className="nav-tab" style={styles.tabButton(activeTab === 'home')} onClick={() => setActiveTab('home')}>Home</button>
//         <button className="nav-tab" style={styles.tabButton(activeTab === 'about')} onClick={() => setActiveTab('about')}>About</button>
//         <button className="nav-tab" style={styles.tabButton(activeTab === 'gallery')} onClick={() => setActiveTab('gallery')}>Gallery</button>
//         <button className="nav-tab" style={styles.tabButton(activeTab === 'contact')} onClick={() => setActiveTab('contact')}>Contact</button>
//       </nav>

//       <div style={styles.bentoWrapper}>

//         {/* Decorative Fluid Text Line */}
//         <div style={{...styles.cell(12, 1, 'transparent'), padding: '0', border: 'none', justifyContent: 'center'}}>
//           <div style={styles.marqueeContainer}>
//             <div style={styles.marqueeTrack}>
//               ASHISH MORE • CREATIVE INSIGHTS • PORTFOLIO SPACE • INSTAGRAM • SNAPCHAT • FACEBOOK • GITHUB • PINTEREST • TWITTER • 
//             </div>
//           </div>
//         </div>

//         {/* Home Tab: Ultra-Minimal Stark Landing Screen */}
//         {activeTab === 'home' && (
//           <div style={{...styles.cell(12, 4, 'transparent'), boxShadow: 'none', border: 'none', alignItems: 'center', justifyContent: 'center', textAlign: 'center', minHeight: '60vh'}} className="grid-cell">
//             <img src="https://unsplash.com" alt="Ashish More Profile" style={{...styles.avatar, marginBottom: '25px'}} />
//             <h1 style={{ fontSize: '4.5rem', fontWeight: '900', margin: '0 0 15px 0', letterSpacing: '-2px', color: theme.textMain, lineHeight: '1' }}>
//               Ashish More
//             </h1>
//             <p style={{ color: theme.textMuted, fontSize: '1.25rem', margin: '0 auto 30px auto', lineHeight: '1.6', maxWidth: '550px', fontWeight: '400' }}>
//               Curating soft, interactive visual landscapes and minimalist digital spaces from a modern aesthetic perspective.
//             </p>
//             <div style={{ display: 'flex', gap: '15px', alignItems: 'center', justifyContent: 'center' }}>
//               <span style={{ fontSize: '0.8rem', fontWeight: '700', letterSpacing: '2px', color: '#4f6ef2' }}>LOCAL SYSTEM CLOCK</span>
//               <span style={{ fontSize: '1.1rem', fontFamily: 'monospace', fontWeight: '700', color: theme.textMain }}>{currentTime}</span>
//             </div>
//           </div>
//         )}

//         {/* About Tab */}
//         {activeTab === 'about' && (
//           <div style={styles.cell(12, 3)} className="grid-cell">
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', color: '#4f6ef2' }}>IDENTITY OVERVIEW</span>
//               <h2 style={{ fontSize: '2rem', margin: '6px 0 20px 0', fontWeight: '900', letterSpacing: '-0.5px' }}>About Me</h2>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '35px', alignItems: 'center' }}>
//               <p style={{ color: theme.textMuted, fontSize: '1.05rem', lineHeight: '1.7', margin: 0 }}>
//                 I design elegant user experiences by combining clean layout grids with soft color harmonies. My goal is to build digital structures that prioritize visual clarity, smooth interactions, and thoughtful spacing.
//               </p>
//               <div style={{ padding: '25px', backgroundColor: theme.accentMint, borderRadius: '24px', border: '1px solid rgba(255,255,255,0.5)' }}>
//                 <h4 style={{ margin: '0 0 10px 0', color: '#1b835a', fontWeight: '700' }}>Current Fields of Focus</h4>
//                 <ul style={{ margin: 0, paddingLeft: '20px', color: theme.textMain, lineHeight: '1.6', fontSize: '0.95rem' }}>
//                   <li>Asymmetric Space Composition</li>
//                   <li>Minimalist Typography Systems</li>
//                   <li>High-Fidelity Pastel Color Landscapes</li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Gallery Tab */}
//         {activeTab === 'gallery' && (
//           <div style={styles.cell(12, 3)} className="grid-cell">
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', color: '#e03c6e' }}>VISUAL SELECTION // SNAPSHOTS</span>
//               <h2 style={{ fontSize: '1.8rem', margin: '4px 0 20px 0', fontWeight: '800' }}>Photo Album</h2>
//             </div>
//             <div style={styles.albumGrid}>
//               {photoGallery.map((img) => (
//                 <img 
//                   key={img.id}
//                   src={img.url} 
//                   alt={img.title} 
//                   style={styles.albumImage} 
//                   className="photo-frame" 
//                   onClick={() => setSelectedPhoto(img.url)}
//                 />
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Contact Tab: Complete Communication Matrix with Branded Interaction */}
//         {activeTab === 'contact' && (
//           <>
//             {/* Direct Communication Channels */}
//             <div style={styles.cell(5, 3)} className="grid-cell">
//               <div>
//                 <div style={styles.iconWrap(theme.accentMint)}>
//                   <span style={{ color: '#1b835a', fontSize: '1.4rem' }}>✉</span>
//                 </div>
//                 <span style={{ fontSize: '0.75rem', fontWeight: '700', color: theme.textMuted }}>SECURE COMMS EMAIL</span>
//                 <br />
//                 <a href="mailto:hello@ashishmore.com" style={styles.connectLink}>hello@ashishmore.com</a>
//               </div>
//               <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: '20px', marginTop: '20px' }}>
//                 <div style={styles.iconWrap(theme.accentRose)}>
//                   <span style={{ color: '#e03c6e', fontSize: '1.4rem' }}>☎</span>
//                 </div>
//                 <span style={{ fontSize: '0.75rem', fontWeight: '700', color: theme.textMuted }}>TELEPHONIC CALL ENDPOINT</span>
//                 <br />
//                 <a href="tel:+919876543210" style={{ ...styles.connectLink, fontSize: '1.3rem', color: '#4f6ef2' }}>+91 98765 43210</a>
//               </div>
//             </div>

//             {/* Social Network Grid featuring Brand-specific Hover Colors */}
//             <div style={styles.cell(7, 3)} className="grid-cell" { ...{style: {...styles.cell(7,3), backgroundColor: theme.accentLavender}} }>
//               <div>
//                 <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', color: '#4f6ef2' }}>CONNECTIVITY NODES</span>
//                 <h3 style={{ fontSize: '1.5rem', margin: '4px 0 15px 0', fontWeight: '800' }}>Social Matrix Channels</h3>
//               </div>
//               <div style={styles.socialGrid}>
//                 <a href="https://snapchat.com" target="_blank" rel="noreferrer" className="social-badge snapchat-btn">Snapchat</a>
//                 <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-badge instagram-btn">Instagram</a>
//                 <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-badge facebook-btn">Facebook</a>
//                 <a href="https://twitter.com" target="_blank" rel="noreferrer" className="social-badge twitter-btn">Twitter</a>
//                 <a href="https://github.com" target="_blank" rel="noreferrer" className="social-badge github-btn">GitHub</a>
//                 <a href="https://pinterest.com" target="_blank" rel="noreferrer" className="social-badge pinterest-btn">Pinterest</a>
//                 <a href="https://spotify.com" target="_blank" rel="noreferrer" className="social-badge spotify-btn">Spotify</a>
//               </div>
//             </div>
//           </>
//         )}

//       </div>
//     </div>
//   );
// }
// ---------------------------------------------------------------------------------------------------------------------------
// import React, { useState, useEffect } from 'react';

// export default function PremiumHighContrastPortfolio() {
//   const [currentTime, setCurrentTime] = useState('');
//   const [selectedPhoto, setSelectedPhoto] = useState(null);
//   const [activeTab, setActiveTab] = useState('home');
//   // High-contrast theme switcher states: 'light' (white), 'grey', 'dark' (black), 'yellow'
//   const [activeTheme, setActiveTheme] = useState('light');

//   useEffect(() => {
//     const updateTime = () => {
//       const now = new Date();
//       setCurrentTime(now.toTimeString().split(' ')[0]);
//     };
//     updateTime();
//     const interval = setInterval(updateTime, 1000);
//     return () => clearInterval(interval);
//   }, []);

//   // Comprehensive VCF (vCard) Contact download protocol generator
//   const downloadVCard = () => {
//     const vcardData = [
//       'BEGIN:VCARD',
//       'VERSION:3.0',
//       'FN:Ashish More',
//       'ORG:Ashirwad Villa & A17 Water',
//       'TEL;TYPE=CELL,VOICE:+919876543210',
//       'EMAIL;TYPE=PREF,INTERNET:hello@ashishmore.com',
//       'URL:https://ashish1761.github.io/A17/',
//       'NOTE:Zodiac: Aries | Booking: Ashirwad Villa',
//       'END:VCARD'
//     ].join('\n');

//     const blob = new Blob([vcardData], { type: 'text/vcard;charset=utf-8;' });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', 'Ashish_More.vcf');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // High-performance geometric CSS architecture animations & themes
//   const structuralStyles = `
//     @keyframes textExpand {
//       0% { letter-spacing: -2px; opacity: 0; }
//       100% { letter-spacing: 2px; opacity: 1; }
//     }
//     @keyframes borderPulse {
//       0% { border-color: rgba(0,0,0,0.1); }
//       50% { border-color: #ffcc00; }
//       100% { border-color: rgba(0,0,0,0.1); }
//     }
//     @keyframes gridWarp {
//       0% { background-position: 0px 0px; }
//       100% { background-position: 30px 30px; }
//     }
//     .grid-cell {
//       transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
//     }
//     .grid-cell:hover {
//       transform: translateY(-8px) scale(1.01);
//       box-shadow: 0 25px 50px rgba(0,0,0,0.15);
//     }
//     .action-btn {
//       transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
//       cursor: pointer;
//     }
//     .action-btn:hover {
//       transform: scale(1.05);
//       filter: brightness(0.9);
//     }
//     .theme-selector {
//       transition: all 0.2s ease;
//     }
//     .theme-selector:hover {
//       transform: scale(1.2);
//     }
//   `;

//   // Color Mapping Matrix configurations
//   const themeMap = {
//     light: { bg: '#ffffff', surface: '#f4f4f4', border: '#e0e0e0', text: '#000000', textMuted: '#666666', accent: '#ffcc00' },
//     grey: { bg: '#2e2e2e', surface: '#3a3a3a', border: '#4a4a4a', text: '#ffffff', textMuted: '#b2b2b2', accent: '#ffcc00' },
//     dark: { bg: '#000000', surface: '#121212', border: '#222222', text: '#ffffff', textMuted: '#888888', accent: '#ffcc00' },
//     yellow: { bg: '#ffcc00', surface: '#ffffff', border: '#000000', text: '#000000', textMuted: '#333333', accent: '#000000' }
//   };

//   const activePalette = themeMap[activeTheme];

//   const styles = {
//     container: {
//       backgroundColor: activePalette.bg,
//       color: activePalette.text,
//       fontFamily: '"Impact", "Arial Black", sans-serif',
//       minHeight: '100vh',
//       padding: '40px 20px',
//       position: 'relative',
//       overflowX: 'hidden',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       transition: 'background-color 0.5s ease, color 0.5s ease'
//     },
//     techOverlay: {
//       position: 'absolute',
//       inset: 0,
//       backgroundImage: `linear-gradient(${activePalette.border} 1px, transparent 1px), linear-gradient(90deg, ${activePalette.border} 1px, transparent 1px)`,
//       backgroundSize: '30px 30px',
//       opacity: 0.15,
//       pointerEvents: 'none',
//       animation: 'gridWarp 10s linear infinite'
//     },
//     topControlRow: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       width: '100%',
//       maxWidth: '1200px',
//       marginBottom: '40px',
//       zIndex: 30
//     },
//     palettePicker: {
//       display: 'flex',
//       gap: '10px',
//       background: activePalette.surface,
//       padding: '10px 20px',
//       borderRadius: '40px',
//       border: `2px solid ${activePalette.text}`
//     },
//     tabBar: {
//       display: 'inline-flex',
//       backgroundColor: activePalette.surface,
//       padding: '6px',
//       borderRadius: '0px',
//       gap: '2px',
//       zIndex: 20,
//       border: `3px solid ${activePalette.text}`
//     },
//     tabButton: (isActive) => ({
//       padding: '12px 28px',
//       borderRadius: '0px',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '1rem',
//       fontWeight: '900',
//       textTransform: 'uppercase',
//       letterSpacing: '1px',
//       color: isActive ? activePalette.bg : activePalette.text,
//       backgroundColor: isActive ? activePalette.text : 'transparent',
//       transition: 'all 0.3s ease'
//     }),
//     bentoWrapper: {
//       width: '100%',
//       maxWidth: '1200px',
//       display: 'grid',
//       gridTemplateColumns: 'repeat(12, 1fr)',
//       gridAutoRows: 'minmax(140px, auto)',
//       gap: '24px',
//       position: 'relative',
//       zIndex: 10
//     },
//     cell: (colSpan, rowSpan, bg = activePalette.surface) => ({
//       gridColumn: `span ${colSpan}`,
//       gridRow: `span ${rowSpan}`,
//       backgroundColor: bg,
//       borderRadius: '0px',
//       border: `3px solid ${activePalette.text}`,
//       padding: '35px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       position: 'relative',
//       overflow: 'hidden'
//     }),
//     massiveHeader: {
//       fontSize: '6.5rem',
//       fontWeight: '900',
//       lineHeight: '0.85',
//       textTransform: 'uppercase',
//       letterSpacing: '-2px',
//       margin: '0 0 15px 0',
//       animation: 'textExpand 1s cubic-bezier(0.25, 1, 0.5, 1) forwards'
//     },
//     avatarBlock: {
//       width: '150px',
//       height: '150px',
//       borderRadius: '0px',
//       objectFit: 'cover',
//       border: `4px solid ${activePalette.text}`
//     },
//     vcardTrigger: {
//       background: activePalette.text,
//       color: activePalette.bg,
//       border: 'none',
//       padding: '16px 30px',
//       fontSize: '1rem',
//       fontWeight: '900',
//       textTransform: 'uppercase',
//       letterSpacing: '1px',
//       marginTop: '20px',
//       display: 'inline-block',
//       textAlign: 'center'
//     },
//     businessGrid: {
//       display: 'grid',
//       gridTemplateColumns: '1fr 1fr',
//       gap: '20px',
//       width: '100%',
//       height: '100%'
//     },
//     businessCard: {
//       padding: '25px',
//       background: activePalette.bg,
//       border: `2px solid ${activePalette.text}`,
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       textDecoration: 'none',
//       color: activePalette.text
//     },
//     zodiacBadge: {
//       position: 'absolute',
//       right: '20px',
//       top: '20px',
//       fontSize: '4rem',
//       opacity: 0.15,
//       fontWeight: '900'
//     }
//   };

//   const galleryImages = [
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com"
//   ];

//   return (
//     <div style={styles.container}>
//       <style>{structuralStyles}</style>
//       <div style={styles.techOverlay} />

//       {/* Lightbox Modals */}
//       {selectedPhoto && (
//         <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.95)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setSelectedPhoto(null)}>
//           <img src={selectedPhoto} alt="Expanded visual perspective" style={{ maxWidth: '90%', maxHeight: '85%', border: `4px solid ${activePalette.accent}` }} />
//         </div>
//       )}

//       {/* Top Interface Control Layer */}
//       <div style={styles.topControlRow}>
//         {/* Dynamic Theme Selection Matrix */}
//         <div style={styles.palettePicker}>
//           <div className="theme-selector" onClick={() => setActiveTheme('light')} style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#ffffff', border: '1px solid #000', cursor: 'pointer' }} />
//           <div className="theme-selector" onClick={() => setActiveTheme('grey')} style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#888888', border: '1px solid #000', cursor: 'pointer' }} />
//           <div className="theme-selector" onClick={() => setActiveTheme('dark')} style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#000000', border: '1px solid #fff', cursor: 'pointer' }} />
//           <div className="theme-selector" onClick={() => setActiveTheme('yellow')} style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#ffcc00', border: '1px solid #000', cursor: 'pointer' }} />
//         </div>

//         {/* Global Modular Tab Navigation */}
//         <nav style={styles.tabBar}>
//           {['home', 'about', 'business', 'gallery', 'contact'].map((tab) => (
//             <button key={tab} className="nav-tab" style={styles.tabButton(activeTab === tab)} onClick={() => setActiveTab(tab)}>
//               {tab}
//             </button>
//           ))}
//         </nav>
//       </div>

//       <div style={styles.bentoWrapper}>

//         {/* Home Tab - Brutalist Minimalist Poster Impact Layout */}
//         {activeTab === 'home' && (
//           <div style={{ ...styles.cell(12, 4, 'transparent'), border: 'none', alignItems: 'center', justifyContent: 'center', textAlign: 'center', minHeight: '55vh' }} className="grid-cell">

//             <h1 style={styles.massiveHeader}>Ashish More</h1>
//             <p style={{ color: activePalette.textMuted, fontSize: '1.4rem', fontFamily: 'sans-serif', maxWidth: '650px', margin: '0 auto 25px auto', fontWeight: 'bold', lineHeight: '1.4' }}>
//               Digital Architecture. Premium High-Contrast Layouts. Fluid Structural Control Fields.
//             </p>
//             <div style={{ fontSize: '1.2rem', fontWeight: '900', letterSpacing: '2px' }}>
//               SYSTEM METADATA // {currentTime}
//             </div>
//           </div>
//         )}

//         {/* About Tab - Zodiac Aries Data Integration */}
//         {activeTab === 'about' && (
//           <div style={styles.cell(12, 3)} className="grid-cell">
//             <div style={styles.zodiacBadge}>♈</div>
//             <div>
//               <span style={{ fontSize: '0.8rem', fontWeight: '900', color: activePalette.accent, letterSpacing: '2px' }}>ZODIAC ALIGNMENT // ARIES CORE</span>
//               <h2 style={{ fontSize: '3rem', fontWeight: '900', textTransform: 'uppercase', margin: '5px 0 20px 0' }}>The Fire Sign Identity</h2>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', fontFamily: 'sans-serif' }}>
//               <p style={{ color: activePalette.textMuted, fontSize: '1.1rem', lineHeight: '1.6', margin: 0, fontWeight: '500' }}>
//                 As an <strong>Aries</strong>, my architectural direction matches my cosmic profile: pioneer leadership, high kinetic energy, and bold confidence. I create sharp layouts and handle complex engineering systems without compromise.
//               </p>
//               <div style={{ padding: '25px', background: activePalette.bg, border: `2px solid ${activePalette.text}` }}>
//                 <h4 style={{ margin: '0 0 10px 0', textTransform: 'uppercase', fontWeight: '900' }}>Cosmic Alignment Properties</h4>
//                 <div style={{ fontSize: '0.95rem', color: activePalette.textMuted, lineHeight: '1.6' }}>
//                   • Element: Fire | Ruler: Mars<br />
//                   • Traits: Courageous, Dynamic, Highly Competitive<br />
//                   • Architecture Focus: Clean lines, fast execution speed
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Business Tab - Villa Booking and A17 Water System Networks */}
//         {activeTab === 'business' && (
//           <div style={styles.cell(12, 4)} className="grid-cell">
//             <div>
//               <span style={{ fontSize: '0.8rem', fontWeight: '900', color: activePalette.accent, letterSpacing: '2px' }}>ENTERPRISE DIRECTORY // LIVE ASSETS</span>
//               <h2 style={{ fontSize: '3rem', fontWeight: '900', textTransform: 'uppercase', margin: '5px 0 25px 0' }}>Business Portfolio</h2>
//             </div>

//             <div style={styles.businessGrid}>
//               {/* Ashirwad Villa Integration Endpoint */}
//               <a href="https://www.instagram.com/ashirwad_villa17?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noreferrer" className="action-btn" style={styles.businessCard}>
//                 <div>
//                   <h3 style={{ fontSize: '1.8rem', fontWeight: '900', margin: '0 0 10px 0', textTransform: 'uppercase' }}>Ashirwad Villa</h3>
//                   <p style={{ fontFamily: 'sans-serif', color: activePalette.textMuted, fontSize: '0.95rem', lineHeight: '1.5', margin: 0 }}>
//                     Premium destination space luxury villa booking gateway. Review structural design parameters, availability maps, and luxury amenities.
//                   </p>
//                 </div>
//                 <span style={{ fontWeight: '900', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '15px', color: activePalette.accent }}>Launch Villa Reservation Layer ↗</span>
//               </a>

//               {/* A17 Water Project Integration Endpoint */}
//               <a href="https://ashish1761.github.io/A17/" target="_blank" rel="noreferrer" className="action-btn" style={styles.businessCard}>
//                 <div>
//                   <h3 style={{ fontSize: '1.8rem', fontWeight: '900', margin: '0 0 10px 0', textTransform: 'uppercase' }}>A17 Water Systems</h3>
//                   <p style={{ fontFamily: 'sans-serif', color: activePalette.textMuted, fontSize: '0.95rem', lineHeight: '1.5', margin: 0 }}>
//                     High-purity algorithmic filtration fluid infrastructure network. Access production architecture documentation, compliance parameters, and systemic supply nodes.
//                   </p>
//                 </div>
//                 <span style={{ fontWeight: '900', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '15px', color: activePalette.accent }}>Verify A17 Web Domain ↗</span>
//               </a>
//             </div>
//           </div>
//         )}

//         {/* Gallery Tab */}
//         {activeTab === 'gallery' && (
//           <div style={styles.cell(12, 3)} className="grid-cell">
//             <div>
//               <span style={{ fontSize: '0.8rem', fontWeight: '900', color: activePalette.accent, letterSpacing: '2px' }}>VISUAL ARCHIVE INDEX</span>
//               <h2 style={{ fontSize: '2.5rem', fontWeight: '900', textTransform: 'uppercase', margin: '5px 0 20px 0' }}>Photo Vault Storage</h2>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '15px' }}>
//               {galleryImages.map((src, idx) => (
//                 <img key={idx} src={src} alt={`Asset ${idx}`} style={{ width: '100%', height: '140px', objectFit: 'cover', border: `2px solid ${activePalette.text}`, cursor: 'zoom-in' }} onClick={() => setSelectedPhoto(src)} />
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Contact Tab - Native Device vCard Generator & Social Profiles */}
//         {activeTab === 'contact' && (
//           <>
//             {/* Device Native Contact Backup Card */}
//             <div style={styles.cell(5, 3)} className="grid-cell">
//               <div>
//                 <span style={{ fontSize: '0.8rem', fontWeight: '900', color: activePalette.accent, letterSpacing: '1px' }}>HARDWARE STORAGE INTERFACE</span>
//                 <h3 style={{ fontSize: '1.8rem', fontWeight: '900', margin: '5px 0 15px 0', textTransform: 'uppercase' }}>Save Identity</h3>
//                 <p style={{ fontFamily: 'sans-serif', color: activePalette.textMuted, fontSize: '0.9rem', lineHeight: '1.5', margin: 0 }}>
//                   Inject Ashish More's profile coordinates into your device address book. Generates a physical vCard protocol payload.
//                 </p>
//               </div>
//               <button onClick={downloadVCard} className="action-btn" style={styles.vcardTrigger}>
//                 Download Address Contact VCF ↓
//               </button>
//             </div>

//             {/* Social Network Routing Panel */}
//             <div style={styles.cell(7, 3)} className="grid-cell">
//               <div>
//                 <span style={{ fontSize: '0.8rem', fontWeight: '900', color: activePalette.accent, letterSpacing: '1px' }}>COMMS ENDPOINTS</span>
//                 <h3 style={{ fontSize: '1.8rem', fontWeight: '900', margin: '5px 0 20px 0', textTransform: 'uppercase' }}>Communications Terminal</h3>
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontFamily: 'sans-serif' }}>
//                 <a href="https://snapchat.com" target="_blank" rel="noreferrer" style={{ padding: '14px', border: `2px solid ${activePalette.text}`, textDecoration: 'none', color: activePalette.text, fontWeight: '700', fontSize: '0.85rem', textAlign: 'center', background: activePalette.bg }}>Snapchat</a>
//                 <a href="https://instagram.com" target="_blank" rel="noreferrer" style={{ padding: '14px', border: `2px solid ${activePalette.text}`, textDecoration: 'none', color: activePalette.text, fontWeight: '700', fontSize: '0.85rem', textAlign: 'center', background: activePalette.bg }}>Instagram</a>
//                 <a href="https://facebook.com" target="_blank" rel="noreferrer" style={{ padding: '14px', border: `2px solid ${activePalette.text}`, textDecoration: 'none', color: activePalette.text, fontWeight: '700', fontSize: '0.85rem', textAlign: 'center', background: activePalette.bg }}>Facebook</a>
//                 <a href="https://twitter.com" target="_blank" rel="noreferrer" style={{ padding: '14px', border: `2px solid ${activePalette.text}`, textDecoration: 'none', color: activePalette.text, fontWeight: '700', fontSize: '0.85rem', textAlign: 'center', background: activePalette.bg }}>Twitter</a>
//                 <a href="https://github.com" target="_blank" rel="noreferrer" style={{ padding: '14px', border: `2px solid ${activePalette.text}`, textDecoration: 'none', color: activePalette.text, fontWeight: '700', fontSize: '0.85rem', textAlign: 'center', background: activePalette.bg }}>GitHub</a>
//                 <a href="https://pinterest.com" target="_blank" rel="noreferrer" style={{ padding: '14px', border: `2px solid ${activePalette.text}`, textDecoration: 'none', color: activePalette.text, fontWeight: '700', fontSize: '0.85rem', textAlign: 'center', background: activePalette.bg }}>Pinterest</a>
//               </div>
//             </div>
//           </>
//         )}

//       </div>
//     </div>
//   );
// }
// // ---------------------------------------------------------------------------------------------------------------------------------------------------
// import React, { useState, useEffect } from 'react';

// export default function AvantGardeHighMotionPortfolio() {
//   const [currentTime, setCurrentTime] = useState('');
//   const [selectedPhoto, setSelectedPhoto] = useState(null);
//   const [activeTab, setActiveTab] = useState('home');
//   // Strict palette switcher: 'white', 'grey', 'black', 'yellow'
//   const [activeTheme, setActiveTheme] = useState('white');

//   useEffect(() => {
//     const updateTime = () => {
//       const now = new Date();
//       setCurrentTime(now.toTimeString().split(' ')[0]);
//     };
//     updateTime();
//     const interval = setInterval(updateTime, 1000);
//     return () => clearInterval(interval);
//   }, []);

//   // Native vCard Download Protocol Engine
//   const downloadVCard = () => {
//     const vcardData = [
//       'BEGIN:VCARD',
//       'VERSION:3.0',
//       'FN:Ashish More',
//       'ORG:Ashirwad Villa & A17 Water',
//       'TEL;TYPE=CELL,VOICE:+919876543210',
//       'EMAIL;TYPE=PREF,INTERNET:hello@ashishmore.com',
//       'URL:https://github.io',
//       'NOTE:Zodiac: Aries | Booking: Ashirwad Villa',
//       'END:VCARD'
//     ].join('\n');

//     const blob = new Blob([vcardData], { type: 'text/vcard;charset=utf-8;' });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', 'Ashish_More.vcf');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // High-Fidelity Fluid Animations & Hardware Accelerated Motions
//   const fluidAnimations = `
//     @keyframes spinZodiac {
//       0% { transform: rotate(0deg) scale(1); opacity: 0.1; }
//       50% { transform: rotate(180deg) scale(1.1); opacity: 0.2; }
//       100% { transform: rotate(360deg) scale(1); opacity: 0.1; }
//     }
//     @keyframes kineticSlide {
//       0% { transform: translateX(0%); }
//       100% { transform: translateX(-50%); }
//     }
//     @keyframes cardEntry {
//       0% { opacity: 0; transform: scale(0.92) translateY(30px); filter: blur(10px); }
//       100% { opacity: 1; transform: scale(1) translateY(0); filter: blur(0); }
//     }
//     @keyframes wavePulse {
//       0%, 100% { transform: scaleY(1); }
//       50% { transform: scaleY(0.4); }
//     }
//     @keyframes gradientShift {
//       0% { background-position: 0% 50%; }
//       50% { background-position: 100% 50%; }
//       100% { background-position: 0% 50%; }
//     }

//     .animated-grid-cell {
//       animation: cardEntry 0.7s cubic-bezier(0.19, 1, 0.22, 1) forwards;
//       transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
//     }
//     .animated-grid-cell:hover {
//       transform: translateY(-12px) scale(1.02) rotateX(2deg) rotateY(-1deg);
//       box-shadow: 0 40px 80px rgba(0,0,0,0.18);
//     }

//     .interactive-btn {
//       position: relative;
//       overflow: hidden;
//       transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
//     }
//     .interactive-btn:hover {
//       transform: translateY(-4px) scale(1.05);
//       box-shadow: 0 15px 30px rgba(0,0,0,0.15);
//     }
//     .interactive-btn:active {
//       transform: translateY(0) scale(0.98);
//     }

//     .media-vault-img {
//       transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1);
//     }
//     .media-vault-img:hover {
//       transform: scale(1.12);
//       filter: contrast(1.1) brightness(1.05);
//     }

//     .theme-trigger {
//       transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//     }
//     .theme-trigger:hover {
//       transform: scale(1.3) rotate(15deg);
//     }

//     .vcf-pulse {
//       position: relative;
//     }
//     .vcf-pulse::after {
//       content: '';
//       position: absolute;
//       inset: 0;
//       border: 2px solid currentColor;
//       border-radius: inherit;
//       animation: wavePulse 2s infinite ease-in-out;
//       opacity: 0;
//     }
//   `;

//   // Color Mapping Configurations
//   const palettes = {
//     white: { bg: '#ffffff', surface: '#f5f5f7', border: '#e5e5ea', text: '#1c1c1e', muted: '#8e8e93', accent: '#000000', secondary: '#f5f5f7' },
//     grey: { bg: '#1c1c1e', surface: '#2c2c2e', border: '#3a3a3c', text: '#ffffff', muted: '#aeaeb2', accent: '#ffffff', secondary: '#3a3a3c' },
//     black: { bg: '#000000', surface: '#121212', border: '#222222', text: '#ffffff', muted: '#666666', accent: '#ffffff', secondary: '#1c1c1e' },
//     yellow: { bg: '#ffcc00', surface: '#ffffff', border: '#000000', text: '#000000', muted: '#3a3a3c', accent: '#000000', secondary: '#ffcc00' }
//   };

//   const activePalette = palettes[activeTheme];

//   const styles = {
//     container: {
//       backgroundColor: activePalette.bg,
//       color: activePalette.text,
//       fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif',
//       minHeight: '100vh',
//       padding: '40px 20px',
//       position: 'relative',
//       overflowX: 'hidden',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       transition: 'background-color 0.6s cubic-bezier(0.19, 1, 0.22, 1), color 0.6s cubic-bezier(0.19, 1, 0.22, 1)'
//     },
//     controlHub: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       width: '100%',
//       maxWidth: '1200px',
//       marginBottom: '40px',
//       zIndex: 100,
//       flexWrap: 'wrap',
//       gap: '20px'
//     },
//     themeSelector: {
//       display: 'flex',
//       gap: '12px',
//       background: activePalette.surface,
//       padding: '12px 24px',
//       borderRadius: '30px',
//       border: `2px solid ${activePalette.border}`,
//       boxShadow: '0 10px 30px rgba(0,0,0,0.05)'
//     },
//     navBar: {
//       display: 'inline-flex',
//       backgroundColor: activePalette.surface,
//       padding: '6px',
//       borderRadius: '20px',
//       gap: '4px',
//       border: `1px solid ${activePalette.border}`,
//       boxShadow: '0 10px 30px rgba(0,0,0,0.05)'
//     },
//     navButton: (isActive) => ({
//       padding: '12px 24px',
//       borderRadius: '14px',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '0.9rem',
//       fontWeight: '700',
//       textTransform: 'uppercase',
//       letterSpacing: '0.5px',
//       color: isActive ? activePalette.bg : activePalette.text,
//       backgroundColor: isActive ? activePalette.text : 'transparent',
//       transition: 'all 0.4s cubic-bezier(0.19, 1, 0.22, 1)'
//     }),
//     bentoLayout: {
//       width: '100%',
//       maxWidth: '1200px',
//       display: 'grid',
//       gridTemplateColumns: 'repeat(12, 1fr)',
//       gridAutoRows: 'minmax(140px, auto)',
//       gap: '24px',
//       position: 'relative',
//       zIndex: 10,
//       perspective: '1200px'
//     },
//     cell: (colSpan, rowSpan, bg = activePalette.surface) => ({
//       gridColumn: `span ${colSpan}`,
//       gridRow: `span ${rowSpan}`,
//       backgroundColor: bg,
//       borderRadius: '32px',
//       border: `1px solid ${activePalette.border}`,
//       padding: '35px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       position: 'relative',
//       overflow: 'hidden'
//     }),
//     marqueeWrapper: {
//       overflow: 'hidden',
//       whiteSpace: 'nowrap',
//       width: '100%',
//       display: 'flex',
//       position: 'relative'
//     },
//     marqueeText: {
//       display: 'flex',
//       animation: 'kineticSlide 22s linear infinite',
//       fontSize: '5rem',
//       fontWeight: '900',
//       letterSpacing: '-1px',
//       textTransform: 'uppercase',
//       color: 'transparent',
//       WebkitTextStroke: `1px ${activePalette.border}`
//     },
//     avatar: {
//       width: '130px',
//       height: '130px',
//       borderRadius: '38px',
//       objectFit: 'cover',
//       border: `3px solid ${activePalette.text}`,
//       boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
//     },
//     zodiacGraphic: {
//       position: 'absolute',
//       right: '-20px',
//       top: '-20px',
//       fontSize: '12rem',
//       fontWeight: '900',
//       color: activePalette.text,
//       animation: 'spinZodiac 25s infinite linear',
//       transformOrigin: 'center',
//       pointerEvents: 'none',
//       zIndex: 1
//     },
//     businessGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
//       gap: '20px',
//       width: '100%',
//       height: '100%',
//       marginTop: '15px'
//     },
//     businessCard: {
//       padding: '28px',
//       backgroundColor: activePalette.bg,
//       borderRadius: '24px',
//       border: `1px solid ${activePalette.border}`,
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       textDecoration: 'none',
//       color: activePalette.text
//     },
//     galleryGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(3, 1fr)',
//       gap: '16px',
//       width: '100%',
//       marginTop: '15px'
//     },
//     galleryContainer: {
//       overflow: 'hidden',
//       borderRadius: '20px',
//       height: '140px',
//       border: `1px solid ${activePalette.border}`
//     },
//     socialGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
//       gap: '12px',
//       width: '100%',
//       marginTop: '15px'
//     },
//     socialPill: {
//       padding: '14px',
//       borderRadius: '16px',
//       backgroundColor: activePalette.bg,
//       border: `1px solid ${activePalette.border}`,
//       color: activePalette.text,
//       textDecoration: 'none',
//       fontSize: '0.85rem',
//       fontWeight: '700',
//       textAlign: 'center',
//       display: 'block'
//     },
//     vcardBtn: {
//       backgroundColor: activePalette.text,
//       color: activePalette.bg,
//       border: 'none',
//       padding: '16px 32px',
//       borderRadius: '16px',
//       fontSize: '0.95rem',
//       fontWeight: '800',
//       textTransform: 'uppercase',
//       letterSpacing: '0.5px',
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '8px',
//       marginTop: '15px'
//     },
//     audioCell: {
//       backgroundColor: activeTheme === 'yellow' ? '#000000' : '#121212',
//       borderColor: 'rgba(30,215,96,0.2)'
//     }
//   };

//   const bentoGallery = [
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com"
//   ];

//   return (
//     <div style={styles.container}>
//       <style>{fluidAnimations}</style>

//       {/* Fullscreen Motion Modal Lightbox */}
//       {selectedPhoto && (
//         <div 
//           style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.98)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, cursor: 'zoom-out', backdropFilter: 'blur(15px)' }} 
//           onClick={() => setSelectedPhoto(null)}
//         >
//           <img src={selectedPhoto} alt="Vault Preview" style={{ maxWidth: '88%', maxHeight: '80%', borderRadius: '24px', boxShadow: '0 40px 80px rgba(0,0,0,0.5)', border: `2px solid ${activePalette.accent}`, animation: 'cardEntry 0.4s ease' }} />
//         </div>
//       )}

//       {/* Control Strip Row */}
//       <div style={styles.controlHub}>
//         {/* Strict Theme Pipeline Selector */}
//         <div style={styles.themeSelector}>
//           <div className="theme-trigger" onClick={() => setActiveTheme('white')} style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: '#ffffff', border: '2px solid #000', cursor: 'pointer' }} title="White Theme" />
//           <div className="theme-trigger" onClick={() => setActiveTheme('grey')} style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: '#2c2c2e', border: '2px solid #aeaeb2', cursor: 'pointer' }} title="Grey Theme" />
//           <div className="theme-trigger" onClick={() => setActiveTheme('black')} style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: '#000000', border: '2px solid #fff', cursor: 'pointer' }} title="Black Theme" />
//           <div className="theme-trigger" onClick={() => setActiveTheme('yellow')} style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: '#ffcc00', border: '2px solid #000', cursor: 'pointer' }} title="Yellow Theme" />
//         </div>

//         {/* Stateful Dynamic Navigation Tab Layer */}
//         <nav style={styles.navBar}>
//           {['home', 'about', 'business', 'gallery', 'contact'].map((tab) => (
//             <button key={tab} style={styles.navButton(activeTab === tab)} onClick={() => setActiveTab(tab)}>
//               {tab}
//             </button>
//           ))}
//         </nav>
//       </div>

//       <div style={styles.bentoLayout}>

//         {/* Kinetic Accent Marquee Strip */}
//         <div style={{...styles.cell(12, 1, 'transparent'), padding: '0', border: 'none', justifyContent: 'center'}}>
//           <div style={styles.marqueeWrapper}>
//             <div style={styles.marqueeText}>
//               ASHISH MORE • ARIES SIGN • ASHIRWAD VILLA • A17 WATER CHANNELS • SAVE CONTACT LINK • MULTI PALETTE FLOW •&nbsp;
//             </div>
//           </div>
//         </div>

//         {/* HOME VIEWPORT: Ultra Minimalist Poster Grid Landing */}
//         {activeTab === 'home' && (
//           <div style={{ ...styles.cell(12, 4, 'transparent'), border: 'none', alignItems: 'center', justifyContent: 'center', textAlign: 'center', minHeight: '58vh' }} className="animated-grid-cell">
//             <img src="https://unsplash.com" alt="Ashish More Identification Profile" style={styles.avatar} />
//             <h1 style={{ fontSize: '5.5rem', fontWeight: '900', letterSpacing: '-3px', textTransform: 'uppercase', margin: '20px 0 10px 0', lineHeight: 0.9 }}>
//               Ashish More
//             </h1>
//             <p style={{ color: activePalette.muted, fontSize: '1.25rem', maxWidth: '600px', margin: '0 auto 30px auto', lineHeight: '1.5', fontWeight: '500' }}>
//               Blending minimalist structures, spatial property management assets, and fluid filtration product operations.
//             </p>
//             <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', background: activePalette.surface, padding: '10px 20px', borderRadius: '30px', border: `1px solid ${activePalette.border}` }}>
//               <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#ffcc00' }} />
//               <span style={{ fontSize: '0.9rem', fontFamily: 'monospace', fontWeight: '700' }}>METADATA STREAM: {currentTime}</span>
//             </div>
//           </div>
//         )}

//         {/* ABOUT VIEWPORT: Cosmic Zodiac Aries Module */}
//         {activeTab === 'about' && (
//           <div style={styles.cell(12, 3)} className="animated-grid-cell">
//             <div style={styles.zodiacGraphic}>♈</div>
//             <div style={{ zIndex: 5 }}>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2.5px', color: activePalette.accent, textTransform: 'uppercase' }}>COSMIC CONFIGURATION</span>
//               <h2 style={{ fontSize: '2.8rem', fontWeight: '900', textTransform: 'uppercase', margin: '4px 0 20px 0', letterSpacing: '-1px' }}>Zodiac Archetype: Aries</h2>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px', zIndex: 5 }}>
//               <p style={{ color: activePalette.muted, fontSize: '1.05rem', lineHeight: '1.6', margin: 0, fontWeight: '500' }}>
//                 Governed by Mars, the **Aries** fire signature forms the baseline of my operation style: highly dynamic execution vectors, absolute courage in structural implementations, and a natural instinct to pioneer new project layers.
//               </p>
//               <div style={{ padding: '24px', backgroundColor: activePalette.bg, borderRadius: '24px', border: `1px solid ${activePalette.border}` }}>
//                 <span style={{ fontSize: '0.7rem', fontWeight: '800', color: activePalette.muted, display: 'block', marginBottom: '8px', letterSpacing: '1px' }}>ASTROLOGICAL PARAMETERS</span>
//                 <div style={{ fontSize: '0.9rem', lineHeight: '1.6', fontWeight: '600' }}>
//                   • Quadruplicity: Cardinal Force | Element: Fire<br />
//                   • Core Focus: High Kinetic Action, Independent Vision<br />
//                   • Interface Strategy: Bold contrasts, instant load motions
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* BUSINESS VIEWPORT: Ashirwad Villa Booking Hub & A17 Fluid Operations */}
//         {activeTab === 'business' && (
//           <div style={styles.cell(12, 4)} className="animated-grid-cell">
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', color: activePalette.accent, textTransform: 'uppercase' }}>ENTERPRISE DIRECTORY NODES</span>
//               <h2 style={{ fontSize: '2.8rem', fontWeight: '900', textTransform: 'uppercase', margin: '4px 0 15px 0', letterSpacing: '-1px' }}>Live Asset Operations</h2>
//             </div>

//             <div style={styles.businessGrid}>
//               {/* Ashirwad Villa Link Asset */}
//               <a href="https://instagram.com" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.businessCard}>
//                 <div>
//                   <h3 style={{ fontSize: '1.6rem', fontWeight: '900', margin: '0 0 10px 0', textTransform: 'uppercase' }}>Ashirwad Villa</h3>
//                   <p style={{ color: activePalette.muted, fontSize: '0.9rem', lineHeight: '1.5', margin: 0, fontWeight: '500' }}>
//                     Luxury escape destination hub. Access current pricing structures, check live seasonal calendars, review premium architectural blueprints, and confirm booking request protocols directly.
//                   </p>
//                 </div>
//                 <span style={{ fontWeight: '800', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '20px', color: activePalette.text }}>Open Booking Gateway ↗</span>
//               </a>

//               {/* A17 Water Link Asset */}
//               <a href="https://github.io" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.businessCard}>
//                 <div>
//                   <h3 style={{ fontSize: '1.6rem', fontWeight: '900', margin: '0 0 10px 0', textTransform: 'uppercase' }}>A17 Fluid Infrastructure</h3>
//                   <p style={{ color: activePalette.muted, fontSize: '0.9rem', lineHeight: '1.5', margin: 0, fontWeight: '500' }}>
//                     High-performance algorithmic filtration web system deployment layer. Explore purification technology matrices, compliance parameters, distribution tracking, and supply endpoints.
//                   </p>
//                 </div>
//                 <span style={{ fontWeight: '800', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '20px', color: activePalette.text }}>Verify A17 Network Link ↗</span>
//               </a>
//             </div>
//           </div>
//         )}

//         {/* GALLERY VIEWPORT: Motion Asset Storage Lightbox */}
//         {activeTab === 'gallery' && (
//           <div style={styles.cell(12, 3)} className="animated-grid-cell">
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', color: activePalette.accent, textTransform: 'uppercase' }}>CAPTURED RECORDS // MEDIA STORAGE</span>
//               <h2 style={{ fontSize: '2.5rem', fontWeight: '900', textTransform: 'uppercase', margin: '4px 0 20px 0', letterSpacing: '-1px' }}>Photo Vault Gallery</h2>
//             </div>
//             <div style={styles.galleryGrid}>
//               {bentoGallery.map((url, idx) => (
//                 <div key={idx} style={styles.galleryContainer}>
//                   <img src={url} alt={`Asset Container ${idx}`} className="media-vault-img" style={{ width: '100%', height: '100%', objectFit: 'cover', cursor: 'zoom-in' }} onClick={() => setSelectedPhoto(url)} />
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* CONTACT VIEWPORT: Native Device vCard Generator & Social Profiles */}
//         {activeTab === 'contact' && (
//           <>
//             {/* Device Contact Download Pipeline */}
//             <div style={styles.cell(5, 3)} className="animated-grid-cell">
//               <div>
//                 <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '1px', color: activePalette.muted, textTransform: 'uppercase' }}>DEVICE CONTACT SYNC ENGINE</span>
//                 <h3 style={{ fontSize: '1.8rem', fontWeight: '900', margin: '5px 0 12px 0', textTransform: 'uppercase' }}>Save Address</h3>
//                 <p style={{ color: activePalette.muted, fontSize: '0.9rem', lineHeight: '1.5', margin: 0, fontWeight: '500' }}>
//                   Download and automatically synchronize Ashish More's phone digits, operational email configurations, and business URLs directly into your mobile contact manager database.
//                 </p>
//               </div>
//               <div>
//                 <button onClick={downloadVCard} className="interactive-btn vcf-pulse" style={styles.vcardBtn}>
//                   Save Contact To Phone ↓
//                 </button>
//               </div>
//             </div>

//             {/* Social Grid Matrix Routing Panel */}
//             <div style={styles.cell(7, 3)} className="animated-grid-cell">
//               <div>
//                 <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '1px', color: activePalette.muted, textTransform: 'uppercase' }}>COMMUNICATIONS TERMINAL</span>
//                 <h3 style={{ fontSize: '1.8rem', fontWeight: '900', margin: '5px 0 15px 0', textTransform: 'uppercase' }}>Social Matrix Nodes</h3>
//               </div>
//               <div style={styles.socialGrid}>
//                 <a href="https://snapchat.com" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.socialPill}>Snapchat //</a>
//                 <a href="https://instagram.com" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.socialPill}>Instagram //</a>
//                 <a href="https://facebook.com" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.socialPill}>Facebook //</a>
//                 <a href="https://twitter.com" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.socialPill}>Twitter //</a>
//                 <a href="https://github.com" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.socialPill}>GitHub //</a>
//                 <a href="https://pinterest.com" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.socialPill}>Pinterest //</a>
//               </div>
//             </div>

//             {/* Premium Integrated Audio Layer Block */}
//             <div style={{ ...styles.cell(12, 2), ...styles.audioCell }} className="animated-grid-cell">
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <div>
//                   <span style={{ fontSize: '0.7rem', fontWeight: '800', color: '#1ed760', letterSpacing: '2px', textTransform: 'uppercase' }}>AUDIO CHANNEL ACTIVE</span>
//                   <h4 style={{ fontSize: '1.5rem', fontWeight: '900', color: '#ffffff', margin: '4px 0 2px 0', textTransform: 'uppercase' }}>Midnight Ambient Transmission</h4>
//                   <p style={{ color: '#88a695', fontSize: '0.85rem', margin: 0, fontFamily: 'sans-serif' }}>Curating specialized digital soundtracks and spatial fluid acoustics</p>
//                 </div>
//                 <a href="https://spotify.com" target="_blank" rel="noreferrer" className="interactive-btn" style={{ padding: '14px 28px', backgroundColor: '#1ed760', color: '#ffffff', textDecoration: 'none', borderRadius: '14px', fontSize: '0.85rem', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
//                   Stream Track ↗
//                 </a>
//               </div>
//             </div>
//           </>
//         )}

//       </div>
//     </div>
//   );
// }
// ----------------------------------------------------------------------------------------------------------------------------
// import React, { useState, useEffect } from 'react';

// export default function AvantGardeHighMotionPortfolio() {
//   const [currentTime, setCurrentTime] = useState('');
//   const [selectedPhoto, setSelectedPhoto] = useState(null);
//   const [activeTab, setActiveTab] = useState('home');
//   const [activeTheme, setActiveTheme] = useState('white');
//   const [isMobile, setIsMobile] = useState(false);

//   // Responsive device tracking pipeline
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);

//     const updateTime = () => {
//       const now = new Date();
//       setCurrentTime(now.toTimeString().split(' ')[0]);
//     };
//     updateTime();
//     const interval = setInterval(updateTime, 1000);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       clearInterval(interval);
//     };
//   }, []);

//   const downloadVCard = () => {
//     const vcardData = [
//       'BEGIN:VCARD',
//       'VERSION:3.0',
//       'FN:Ashish More',
//       'ORG:Ashirwad Villa & A17 Water',
//       'TEL;TYPE=CELL,VOICE:+919876543210',
//       'EMAIL;TYPE=PREF,INTERNET:hello@ashishmore.com',
//       'URL:https://github.io',
//       'NOTE:Zodiac: Aries | Booking: Ashirwad Villa',
//       'END:VCARD'
//     ].join('\n');

//     const blob = new Blob([vcardData], { type: 'text/vcard;charset=utf-8;' });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', 'Ashish_More.vcf');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // High-performance keyframes for fluid layout engine + Mobile Responsive Media Queries
//   const fluidAnimations = `
//     @keyframes spinZodiac {
//       0% { transform: rotate(0deg) scale(1); opacity: 0.1; }
//       50% { transform: rotate(180deg) scale(1.1); opacity: 0.2; }
//       100% { transform: rotate(360deg) scale(1); opacity: 0.1; }
//     }
//     @keyframes kineticSlide {
//       0% { transform: translateX(0%); }
//       100% { transform: translateX(-50%); }
//     }
//     @keyframes cardEntry {
//       0% { opacity: 0; transform: scale(0.95) translateY(20px); filter: blur(4px); }
//       100% { opacity: 1; transform: scale(1) translateY(0); filter: blur(0); }
//     }

//     .animated-grid-cell {
//       animation: cardEntry 0.5s cubic-bezier(0.19, 1, 0.22, 1) forwards;
//       transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
//     }

//     @media (min-width: 769px) {
//       .animated-grid-cell:hover {
//         transform: translateY(-8px) scale(1.015);
//         box-shadow: 0 30px 60px rgba(0,0,0,0.12);
//       }
//     }

//     .interactive-btn {
//       transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
//     }
//     @media (min-width: 769px) {
//       .interactive-btn:hover {
//         transform: translateY(-2px) scale(1.02);
//       }
//     }
//     .interactive-btn:active {
//       transform: scale(0.98);
//     }

//     .media-vault-img {
//       transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
//     }
//     @media (min-width: 769px) {
//       .media-vault-img:hover {
//         transform: scale(1.08);
//       }
//     }

//     /* --- Kinetic Cyber Social Ring Modules --- */
//     .social-honeycomb-grid {
//       display: grid;
//       grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
//       gap: 12px;
//       width: 100%;
//       margin-top: 20px;
//     }
//     @media (max-width: 480px) {
//       .social-honeycomb-grid {
//         grid-template-columns: repeat(2, 1fr);
//       }
//     }
//     .cyber-social-node {
//       position: relative;
//       height: 80px;
//       background: rgba(0,0,0,0.02);
//       border-radius: 20px;
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       justifyContent: center;
//       text-decoration: none;
//       overflow: hidden;
//       transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
//     }
//     .cyber-social-node .node-label {
//       font-size: 0.85rem;
//       font-weight: 800;
//       letter-spacing: 0.5px;
//       text-transform: uppercase;
//       z-index: 5;
//       transition: color 0.3s ease;
//     }
//     .cyber-social-node .node-bg-wave {
//       position: absolute;
//       inset: 0;
//       top: 100%;
//       transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
//       z-index: 1;
//       opacity: 0.95;
//     }

//     /* --- Specific Brand Dynamic Hover Maps --- */
//     .snapchat-node .node-label { color: #8e8e93; }
//     .snapchat-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(255, 252, 0, 0.2); }
//     .snapchat-node:hover .node-label { color: #000000; }
//     .snapchat-node:hover .node-bg-wave { top: 0%; background: #FFFC00; }

//     .instagram-node .node-label { color: #8e8e93; }
//     .instagram-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(228, 64, 95, 0.2); }
//     .instagram-node:hover .node-label { color: #ffffff; }
//     .instagram-node:hover .node-bg-wave { 
//       top: 0%; 
//       background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%); 
//     }

//     .facebook-node .node-label { color: #8e8e93; }
//     .facebook-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(24, 119, 242, 0.2); }
//     .facebook-node:hover .node-label { color: #ffffff; }
//     .facebook-node:hover .node-bg-wave { top: 0%; background: #1877F2; }

//     .twitter-node .node-label { color: #8e8e93; }
//     .twitter-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2); }
//     .twitter-node:hover .node-label { color: #ffffff; }
//     .twitter-node:hover .node-bg-wave { top: 0%; background: #000000; }

//     .github-node .node-label { color: #8e8e93; }
//     .github-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(36, 41, 46, 0.2); }
//     .github-node:hover .node-label { color: #ffffff; }
//     .github-node:hover .node-bg-wave { top: 0%; background: #24292e; }

//     .pinterest-node .node-label { color: #8e8e93; }
//     .pinterest-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(230, 0, 35, 0.2); }
//     .pinterest-node:hover .node-label { color: #ffffff; }
//     .pinterest-node:hover .node-bg-wave { top: 0%; background: #E60023; }
//   `;

//   const palettes = {
//     white: { bg: '#ffffff', surface: '#f5f5f7', border: '#e5e5ea', text: '#1c1c1e', muted: '#8e8e93' },
//     grey: { bg: '#1c1c1e', surface: '#2c2c2e', border: '#3a3a3c', text: '#ffffff', muted: '#aeaeb2' },
//     black: { bg: '#000000', surface: '#121212', border: '#222222', text: '#ffffff', muted: '#666666' },
//     yellow: { bg: '#ffcc00', surface: '#ffffff', border: '#000000', text: '#000000', muted: '#3a3a3c' }
//   };

//   const activePalette = palettes[activeTheme];

//   const styles = {
//     container: {
//       backgroundColor: activePalette.bg,
//       color: activePalette.text,
//       fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif',
//       minHeight: '100vh',
//       padding: isMobile ? '20px 16px' : '40px 20px',
//       position: 'relative',
//       overflowX: 'hidden',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       transition: 'background-color 0.4s ease, color 0.4s ease'
//     },
//     controlHub: {
//       display: 'flex',
//       flexDirection: isMobile ? 'column' : 'row',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       width: '100%',
//       maxWidth: '1200px',
//       marginBottom: isMobile ? '24px' : '40px',
//       zIndex: 100,
//       gap: '16px'
//     },
//     themeSelector: {
//       display: 'flex',
//       gap: '12px',
//       background: activePalette.surface,
//       padding: '10px 20px',
//       borderRadius: '30px',
//       border: `1px solid ${activePalette.border}`
//     },
//     navBar: {
//       display: 'inline-flex',
//       backgroundColor: activePalette.surface,
//       padding: '4px',
//       borderRadius: '16px',
//       gap: '2px',
//       border: `1px solid ${activePalette.border}`,
//       width: isMobile ? '100%' : 'auto',
//       overflowX: isMobile ? 'auto' : 'visible',
//       whiteSpace: 'nowrap',
//       WebkitOverflowScrolling: 'touch'
//     },
//     navButton: (isActive) => ({
//       padding: isMobile ? '10px 16px' : '12px 24px',
//       borderRadius: '12px',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: isMobile ? '0.8rem' : '0.9rem',
//       fontWeight: '700',
//       textTransform: 'uppercase',
//       color: isActive ? activePalette.bg : activePalette.text,
//       backgroundColor: isActive ? activePalette.text : 'transparent',
//       transition: 'all 0.3s ease',
//       flex: isMobile ? '1 0 auto' : 'none',
//       textAlign: 'center'
//     }),
//     bentoLayout: {
//       width: '100%',
//       maxWidth: '1200px',
//       display: 'grid',
//       gridTemplateColumns: 'repeat(12, 1fr)',
//       gridAutoRows: 'minmax(120px, auto)',
//       gap: isMobile ? '16px' : '24px',
//       position: 'relative',
//       zIndex: 10
//     },
//     cell: (colSpan, rowSpan, bg = activePalette.surface) => ({
//       gridColumn: isMobile ? 'span 12' : `span ${colSpan}`,
//       gridRow: isMobile ? 'auto' : `span ${rowSpan}`,
//       backgroundColor: bg,
//       borderRadius: isMobile ? '24px' : '32px',
//       border: `1px solid ${activePalette.border}`,
//       padding: isMobile ? '24px' : '35px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       position: 'relative',
//       overflow: 'hidden',
//       gap: isMobile ? '20px' : '0px'
//     }),
//     marqueeWrapper: {
//       overflow: 'hidden',
//       whiteSpace: 'nowrap',
//       width: '100%',
//       display: 'flex'
//     },
//     marqueeText: {
//       display: 'flex',
//       animation: 'kineticSlide 22s linear infinite',
//       fontSize: isMobile ? '2.5rem' : '5rem',
//       fontWeight: '900',
//       color: 'transparent',
//       WebkitTextStroke: `1px ${activePalette.border}`
//     },
//     avatar: {
//       width: isMobile ? '100px' : '130px',
//       height: isMobile ? '100px' : '130px',
//       borderRadius: isMobile ? '28px' : '38px',
//       objectFit: 'cover',
//       border: `3px solid ${activePalette.text}`
//     },
//     zodiacGraphic: {
//       position: 'absolute',
//       right: '-20px',
//       top: '-20px',
//       fontSize: isMobile ? '8rem' : '12rem',
//       fontWeight: '900',
//       color: activePalette.text,
//       animation: 'spinZodiac 25s infinite linear',
//       pointerEvents: 'none',
//       zIndex: 1
//     },
//     businessGrid: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(240px, 1fr))',
//       gap: '16px',
//       width: '100%',
//       marginTop: '15px'
//     },
//     businessCard: {
//       padding: isMobile ? '20px' : '28px',
//       backgroundColor: activePalette.bg,
//       borderRadius: '20px',
//       border: `1px solid ${activePalette.border}`,
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       textDecoration: 'none',
//       color: activePalette.text,
//       gap: '12px'
//     },
//     galleryGrid: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
//       gap: '12px',
//       width: '100%',
//       marginTop: '15px'
//     },
//     vcardBtn: {
//       backgroundColor: activePalette.text,
//       color: activePalette.bg,
//       border: 'none',
//       padding: '14px 28px',
//       borderRadius: '14px',
//       fontSize: '0.9rem',
//       fontWeight: '800',
//       textTransform: 'uppercase',
//       marginTop: '10px',
//       width: isMobile ? '100%' : 'auto',
//       textAlign: 'center',
//       cursor: 'pointer'
//     }
//   };

//   const bentoGallery = [
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com"
//   ];

//   return (
//     <div style={styles.container}>
//       <style>{fluidAnimations}</style>

//       {selectedPhoto && (
//         <div 
//           style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.98)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, cursor: 'zoom-out' }} 
//           onClick={() => setSelectedPhoto(null)}
//         >
//           <img src={selectedPhoto} alt="Vault Preview" style={{ maxWidth: '92%', maxHeight: '80%', borderRadius: '16px', border: `2px solid ${activePalette.text}` }} />
//         </div>
//       )}

//       {/* Control Strip Row */}
//       <div style={styles.controlHub}>
//         <div style={styles.themeSelector}>
//           {['white', 'grey', 'black', 'yellow'].map((t) => (
//             <div 
//               key={t}
//               className="theme-trigger" 
//               onClick={() => setActiveTheme(t)} 
//               style={{ 
//                 width: '20px', 
//                 height: '20px', 
//                 borderRadius: '50%', 
//                 backgroundColor: t === 'white' ? '#fff' : t === 'grey' ? '#2c2c2e' : t === 'black' ? '#000' : '#ffcc00', 
//                 border: `2px solid ${activeTheme === t ? '#ffcc00' : '#000'}`, 
//                 cursor: 'pointer' 
//               }} 
//             />
//           ))}
//         </div>

//         <nav style={styles.navBar}>
//           {['home', 'about', 'business', 'gallery', 'contact'].map((tab) => (
//             <button key={tab} style={styles.navButton(activeTab === tab)} onClick={() => setActiveTab(tab)}>
//               {tab}
//             </button>
//           ))}
//         </nav>
//       </div>

//       <div style={styles.bentoLayout}>
//         <div style={{...styles.cell(12, 1, 'transparent'), padding: '0', border: 'none', justifyContent: 'center'}}>
//           <div style={styles.marqueeWrapper}>
//             <div style={styles.marqueeText}>
//               ASHISH MORE • ARIES SIGN • ASHIRWAD VILLA • A17 WATER CHANNELS • BRAND MATRIX TRANSMISSION •&nbsp;
//             </div>
//           </div>
//         </div>

//         {/* HOME VIEWPORT */}
//         {activeTab === 'home' && (
//           <div style={{ ...styles.cell(12, 4, 'transparent'), border: 'none', alignItems: 'center', justifyContent: 'center', textAlign: 'center', minHeight: isMobile ? '45vh' : '58vh' }} className="animated-grid-cell">
//             <img src="https://unsplash.com" alt="Ashish More" style={styles.avatar} />
//             <h1 style={{ fontSize: isMobile ? '3rem' : '5.5rem', fontWeight: '900', letterSpacing: '-1.5px', textTransform: 'uppercase', margin: '15px 0 10px 0', lineHeight: 1 }}>
//               Ashish More
//             </h1>
//             <p style={{ color: activePalette.muted, fontSize: isMobile ? '1.05rem' : '1.25rem', maxWidth: '600px', margin: '0 auto 20px auto', lineHeight: '1.5' }}>
//               Blending minimalist structures, spatial property management assets, and fluid filtration product operations.
//             </p>
//             <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', background: activePalette.surface, padding: '10px 20px', borderRadius: '30px', border: `1px solid ${activePalette.border}` }}>
//               <span style={{ fontSize: '0.85rem', fontFamily: 'monospace', fontWeight: '700' }}>CLOCK: {currentTime}</span>
//             </div>
//           </div>
//         )}

//         {/* ABOUT VIEWPORT */}
//         {activeTab === 'about' && (
//           <div style={styles.cell(12, 3)} className="animated-grid-cell">
//             <div style={styles.zodiacGraphic}>♈</div>
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', color: activePalette.text, textTransform: 'uppercase' }}>COSMIC CONFIGURATION</span>
//               <h2 style={{ fontSize: isMobile ? '1.8rem' : '2.8rem', fontWeight: '900', textTransform: 'uppercase', margin: '4px 0 20px 0' }}>Zodiac Archetype: Aries</h2>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', zIndex: 5 }}>
//               <p style={{ color: activePalette.muted, fontSize: '1rem', lineHeight: '1.6', margin: 0 }}>
//                 Governed by Mars, the Aries fire signature forms the baseline of my operation style: highly dynamic execution vectors, absolute courage in structural implementations, and a natural instinct to pioneer new project layers.
//               </p>
//               <div style={{ padding: '20px', backgroundColor: activePalette.bg, borderRadius: '20px', border: `1px solid ${activePalette.border}` }}>
//                 <span style={{ fontSize: '0.7rem', fontWeight: '800', color: activePalette.muted, display: 'block', marginBottom: '8px' }}>ASTROLOGICAL PARAMETERS</span>
//                 <div style={{ fontSize: '0.85rem', lineHeight: '1.6', fontWeight: '600' }}>
//                   • Quadruplicity: Cardinal Force | Element: Fire<br />
//                   • Core Focus: High Kinetic Action, Independent Vision
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* BUSINESS VIEWPORT */}
//         {activeTab === 'business' && (
//           <div style={styles.cell(12, 4)} className="animated-grid-cell">
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', textTransform: 'uppercase' }}>ENTERPRISE DIRECTORY NODES</span>
//               <h2 style={{ fontSize: isMobile ? '1.8rem' : '2.8rem', fontWeight: '900', textTransform: 'uppercase', margin: '4px 0 15px 0' }}>Live Asset Operations</h2>
//             </div>

//             <div style={styles.businessGrid}>
//               <a href="https://instagram.com" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.businessCard}>
//                 <div>
//                   <h3 style={{ fontSize: '1.4rem', fontWeight: '900', margin: '0 0 8px 0', textTransform: 'uppercase' }}>Ashirwad Villa</h3>
//                   <p style={{ color: activePalette.muted, fontSize: '0.85rem', lineHeight: '1.5', margin: 0 }}>
//                     Luxury escape destination hub. Access current pricing structures, check live seasonal calendars, review blueprints, and confirm booking protocols directly.
//                   </p>
//                 </div>
//                 <span style={{ fontWeight: '800', fontSize: '0.8rem', textTransform: 'uppercase', marginTop: '10px' }}>Open Booking Gateway ↗</span>
//               </a>

//               <a href="https://github.io" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.businessCard}>
//                 <div>
//                   <h3 style={{ fontSize: '1.4rem', fontWeight: '900', margin: '0 0 8px 0', textTransform: 'uppercase' }}>A17 Fluid Infrastructure</h3>
//                   <p style={{ color: activePalette.muted, fontSize: '0.85rem', lineHeight: '1.5', margin: 0 }}>
//                     High-performance algorithmic filtration web system deployment layer. Explore purification matrices, compliance tracking, and supply endpoints.
//                   </p>
//                 </div>
//                 <span style={{ fontWeight: '800', fontSize: '0.8rem', textTransform: 'uppercase', marginTop: '10px' }}>Verify A17 Network Link ↗</span>
//               </a>
//             </div>
//           </div>
//         )}

//         {/* GALLERY VIEWPORT */}
//         {activeTab === 'gallery' && (
//           <div style={styles.cell(12, 3)} className="animated-grid-cell">
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', textTransform: 'uppercase' }}>CAPTURED RECORDS // MEDIA STORAGE</span>
//               <h2 style={{ fontSize: isMobile ? '1.8rem' : '2.5rem', fontWeight: '900', textTransform: 'uppercase', margin: '4px 0 20px 0' }}>Photo Vault Gallery</h2>
//             </div>
//             <div style={styles.galleryGrid}>
//               {bentoGallery.map((url, idx) => (
//                 <div key={idx} style={{ overflow: 'hidden', borderRadius: '14px', height: isMobile ? '100px' : '140px', border: `1px solid ${activePalette.border}` }}>
//                   <img src={url} alt={`Asset Container ${idx}`} className="media-vault-img" style={{ width: '100%', height: '100%', objectFit: 'cover', cursor: 'zoom-in' }} onClick={() => setSelectedPhoto(url)} />
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* CONTACT VIEWPORT */}
//         {activeTab === 'contact' && (
//           <>
//             <div style={styles.cell(4, 3)} className="animated-grid-cell">
//               <div>
//                 <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '1px', color: activePalette.muted, textTransform: 'uppercase' }}>DEVICE SYNC ENGINE</span>
//                 <h3 style={{ fontSize: '1.5rem', fontWeight: '900', margin: '5px 0 8px 0', textTransform: 'uppercase' }}>Save Address</h3>
//                 <p style={{ color: activePalette.muted, fontSize: '0.85rem', lineHeight: '1.5', margin: 0 }}>
//                   Automatically synchronize Ashish More's contact card parameters straight to your mobile manager database.
//                 </p>
//               </div>
//               <button onClick={downloadVCard} className="interactive-btn" style={styles.vcardBtn}>
//                 Save Contact VCF ↓
//               </button>
//             </div>

//             <div style={styles.cell(8, 3)} className="animated-grid-cell">
//               <div>
//                 <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '1px', color: activePalette.muted, textTransform: 'uppercase' }}>COMMUNICATIONS TERMINAL</span>
//                 <h3 style={{ fontSize: '1.5rem', fontWeight: '900', margin: '5px 0 5px 0', textTransform: 'uppercase' }}>Social Matrix Nodes</h3>
//               </div>

//               <div className="social-honeycomb-grid">
//                 {['snapchat', 'instagram', 'facebook', 'twitter', 'github', 'pinterest'].map((brand) => (
//                   <a key={brand} href={`https://${brand}.com`} target="_blank" rel="noreferrer" className={`cyber-social-node ${brand}-node`}>
//                     <div className="node-bg-wave" />
//                     <span className="node-label">{brand} //</span>
//                   </a>
//                 ))}
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }
// ------------------------------------------------------------------------------------------------------------------

// import React, { useState, useEffect } from 'react';

// export default function AvantGardeHighMotionPortfolio() {
//   const [currentTime, setCurrentTime] = useState('');
//   const [selectedPhoto, setSelectedPhoto] = useState(null);
//   const [activeTab, setActiveTab] = useState('home');
//   const [activeTheme, setActiveTheme] = useState('white');
//   const [isMobile, setIsMobile] = useState(false);

//   // Responsive device tracking & clock synchronization pipelines
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);

//     const updateTime = () => {
//       const now = new Date();
//       setCurrentTime(now.toTimeString().split(' '));
//     };
//     updateTime();
//     const interval = setInterval(updateTime, 1000);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       clearInterval(interval);
//     };
//   }, []);

//   const downloadVCard = () => {
//     const vcardData = [
//       'BEGIN:VCARD',
//       'VERSION:3.0',
//       'FN:Ashish More',
//       'ORG:Ashirwad Villa & A17 Water',
//       'TEL;TYPE=CELL,VOICE:+919876543210',
//       'EMAIL;TYPE=PREF,INTERNET:hello@ashishmore.com',
//       'URL:https://github.io',
//       'NOTE:Zodiac: Aries | Born: 17/06/2001 08:05 AM | Booking: Ashirwad Villa',
//       'END:VCARD'
//     ].join('\n');

//     const blob = new Blob([vcardData], { type: 'text/vcard;charset=utf-8;' });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', 'Ashish_More.vcf');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // High-performance keyframes for fluid layout engine + Mobile Responsive Media Queries
//   const fluidAnimations = `
//     @keyframes spinZodiac {
//       0% { transform: rotate(0deg) scale(1); opacity: 0.1; }
//       50% { transform: rotate(180deg) scale(1.1); opacity: 0.2; }
//       100% { transform: rotate(360deg) scale(1); opacity: 0.1; }
//     }
//     @keyframes kineticSlide {
//       0% { transform: translateX(0%); }
//       100% { transform: translateX(-50%); }
//     }
//     @keyframes cardEntry {
//       0% { opacity: 0; transform: scale(0.95) translateY(20px); filter: blur(4px); }
//       100% { opacity: 1; transform: scale(1) translateY(0); filter: blur(0); }
//     }

//     .animated-grid-cell {
//       animation: cardEntry 0.5s cubic-bezier(0.19, 1, 0.22, 1) forwards;
//       transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
//     }

//     @media (min-width: 769px) {
//       .animated-grid-cell:hover {
//         transform: translateY(-8px) scale(1.015);
//         box-shadow: 0 30px 60px rgba(0,0,0,0.12);
//       }
//     }

//     .interactive-btn {
//       transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
//     }
//     @media (min-width: 769px) {
//       .interactive-btn:hover {
//         transform: translateY(-2px) scale(1.02);
//       }
//     }
//     .interactive-btn:active {
//       transform: scale(0.98);
//     }

//     .media-vault-img {
//       transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
//     }
//     @media (min-width: 769px) {
//       .media-vault-img:hover {
//         transform: scale(1.08);
//       }
//     }

//     /* --- Kinetic Cyber Social Ring Modules --- */
//     .social-honeycomb-grid {
//       display: grid;
//       grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
//       gap: 12px;
//       width: 100%;
//       margin-top: 20px;
//     }
//     @media (max-width: 480px) {
//       .social-honeycomb-grid {
//         grid-template-columns: repeat(2, 1fr);
//       }
//     }
//     .cyber-social-node {
//       position: relative;
//       height: 80px;
//       background: rgba(0,0,0,0.02);
//       border-radius: 20px;
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       justifyContent: center;
//       text-decoration: none;
//       overflow: hidden;
//       transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
//     }
//     .cyber-social-node .node-label {
//       font-size: 0.85rem;
//       font-weight: 800;
//       letter-spacing: 0.5px;
//       text-transform: uppercase;
//       z-index: 5;
//       transition: color 0.3s ease;
//     }
//     .cyber-social-node .node-bg-wave {
//       position: absolute;
//       inset: 0;
//       top: 100%;
//       transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
//       z-index: 1;
//       opacity: 0.95;
//     }

//     /* --- Specific Brand Dynamic Hover Maps --- */
//     .snapchat-node .node-label { color: #8e8e93; }
//     .snapchat-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(255, 252, 0, 0.2); }
//     .snapchat-node:hover .node-label { color: #000000; }
//     .snapchat-node:hover .node-bg-wave { top: 0%; background: #FFFC00; }

//     .instagram-node .node-label { color: #8e8e93; }
//     .instagram-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(228, 64, 95, 0.2); }
//     .instagram-node:hover .node-label { color: #ffffff; }
//     .instagram-node:hover .node-bg-wave { 
//       top: 0%; 
//       background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%); 
//     }

//     .facebook-node .node-label { color: #8e8e93; }
//     .facebook-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(24, 119, 242, 0.2); }
//     .facebook-node:hover .node-label { color: #ffffff; }
//     .facebook-node:hover .node-bg-wave { top: 0%; background: #1877F2; }

//     .twitter-node .node-label { color: #8e8e93; }
//     .twitter-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2); }
//     .twitter-node:hover .node-label { color: #ffffff; }
//     .twitter-node:hover .node-bg-wave { top: 0%; background: #000000; }

//     .github-node .node-label { color: #8e8e93; }
//     .github-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(36, 41, 46, 0.2); }
//     .github-node:hover .node-label { color: #ffffff; }
//     .github-node:hover .node-bg-wave { top: 0%; background: #24292e; }

//     .pinterest-node .node-label { color: #8e8e93; }
//     .pinterest-node:hover { transform: translateY(-4px); box-shadow: 0 10px 20px rgba(230, 0, 35, 0.2); }
//     .pinterest-node:hover .node-label { color: #ffffff; }
//     .pinterest-node:hover .node-bg-wave { top: 0%; background: #E60023; }
//   `;

//   const palettes = {
//     white: { bg: '#ffffff', surface: '#f5f5f7', border: '#e5e5ea', text: '#1c1c1e', muted: '#8e8e93' },
//     grey: { bg: '#1c1c1e', surface: '#2c2c2e', border: '#3a3a3c', text: '#ffffff', muted: '#aeaeb2' },
//     black: { bg: '#000000', surface: '#121212', border: '#222222', text: '#ffffff', muted: '#666666' },
//     yellow: { bg: '#ffcc00', surface: '#ffffff', border: '#000000', text: '#000000', muted: '#3a3a3c' }
//   };

//   const activePalette = palettes[activeTheme];

//   const styles = {
//     container: {
//       backgroundColor: activePalette.bg,
//       color: activePalette.text,
//       fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif',
//       minHeight: '100vh',
//       padding: isMobile ? '20px 16px' : '40px 20px',
//       position: 'relative',
//       overflowX: 'hidden',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       transition: 'background-color 0.4s ease, color 0.4s ease'
//     },
//     controlHub: {
//       display: 'flex',
//       flexDirection: isMobile ? 'column' : 'row',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       width: '100%',
//       maxWidth: '1200px',
//       marginBottom: isMobile ? '24px' : '40px',
//       zIndex: 100,
//       gap: '16px'
//     },
//     themeSelector: {
//       display: 'flex',
//       gap: '12px',
//       background: activePalette.surface,
//       padding: '10px 20px',
//       borderRadius: '30px',
//       border: `1px solid ${activePalette.border}`
//     },
//     navBar: {
//       display: 'inline-flex',
//       backgroundColor: activePalette.surface,
//       padding: '4px',
//       borderRadius: '16px',
//       gap: '2px',
//       border: `1px solid ${activePalette.border}`,
//       width: isMobile ? '100%' : 'auto',
//       overflowX: isMobile ? 'auto' : 'visible',
//       whiteSpace: 'nowrap',
//       WebkitOverflowScrolling: 'touch'
//     },
//     navButton: (isActive) => ({
//       padding: isMobile ? '10px 16px' : '12px 24px',
//       borderRadius: '12px',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: isMobile ? '0.8rem' : '0.9rem',
//       fontWeight: '700',
//       textTransform: 'uppercase',
//       color: isActive ? activePalette.bg : activePalette.text,
//       backgroundColor: isActive ? activePalette.text : 'transparent',
//       transition: 'all 0.3s ease',
//       flex: isMobile ? '1 0 auto' : 'none',
//       textAlign: 'center'
//     }),
//     bentoLayout: {
//       width: '100%',
//       maxWidth: '1200px',
//       display: 'grid',
//       gridTemplateColumns: 'repeat(12, 1fr)',
//       gridAutoRows: 'minmax(120px, auto)',
//       gap: isMobile ? '16px' : '24px',
//       position: 'relative',
//       zIndex: 10
//     },
//     cell: (colSpan, rowSpan, bg = activePalette.surface) => ({
//       gridColumn: isMobile ? 'span 12' : `span ${colSpan}`,
//       gridRow: isMobile ? 'auto' : `span ${rowSpan}`,
//       backgroundColor: bg,
//       borderRadius: isMobile ? '24px' : '32px',
//       border: `1px solid ${activePalette.border}`,
//       padding: isMobile ? '24px' : '35px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       position: 'relative',
//       overflow: 'hidden',
//       gap: isMobile ? '20px' : '0px'
//     }),
//     marqueeWrapper: {
//       overflow: 'hidden',
//       whiteSpace: 'nowrap',
//       width: '100%',
//       display: 'flex'
//     },
//     marqueeText: {
//       display: 'flex',
//       animation: 'kineticSlide 22s linear infinite',
//       fontSize: isMobile ? '2.5rem' : '5rem',
//       fontWeight: '900',
//       color: 'transparent',
//       WebkitTextStroke: `1px ${activePalette.border}`
//     },
//     avatar: {
//       width: isMobile ? '100px' : '130px',
//       height: isMobile ? '100px' : '130px',
//       borderRadius: isMobile ? '28px' : '38px',
//       objectFit: 'cover',
//       border: `3px solid ${activePalette.text}`
//     },
//     zodiacGraphic: {
//       position: 'absolute',
//       right: '-20px',
//       top: '-20px',
//       fontSize: isMobile ? '8rem' : '12rem',
//       fontWeight: '900',
//       color: activePalette.text,
//       animation: 'spinZodiac 25s infinite linear',
//       pointerEvents: 'none',
//       zIndex: 1
//     },
//     businessGrid: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(240px, 1fr))',
//       gap: '16px',
//       width: '100%',
//       marginTop: '15px'
//     },
//     businessCard: {
//       padding: isMobile ? '20px' : '28px',
//       backgroundColor: activePalette.bg,
//       borderRadius: '20px',
//       border: `1px solid ${activePalette.border}`,
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between',
//       textDecoration: 'none',
//       color: activePalette.text,
//       gap: '12px'
//     },
//     galleryGrid: {
//       display: 'grid',
//       gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
//       gap: '12px',
//       width: '100%',
//       marginTop: '15px'
//     },
//     vcardBtn: {
//       backgroundColor: activePalette.text,
//       color: activePalette.bg,
//       border: 'none',
//       padding: '14px 28px',
//       borderRadius: '14px',
//       fontSize: '0.9rem',
//       fontWeight: '800',
//       textTransform: 'uppercase',
//       marginTop: '10px',
//       width: isMobile ? '100%' : 'auto',
//       textAlign: 'center',
//       cursor: 'pointer'
//     }
//   };

//   const bentoGallery = [
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com",
//     "https://unsplash.com"
//   ];

//   return (
//     <div style={styles.container}>
//       <style>{fluidAnimations}</style>

//       {selectedPhoto && (
//         <div 
//           style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.98)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, cursor: 'zoom-out' }} 
//           onClick={() => setSelectedPhoto(null)}
//         >
//           <img src={selectedPhoto} alt="Vault Preview" style={{ maxWidth: '92%', maxHeight: '80%', borderRadius: '16px', border: `2px solid ${activePalette.text}` }} />
//         </div>
//       )}

//       {/* Control Strip Row */}
//       <div style={styles.controlHub}>
//         <div style={styles.themeSelector}>
//           {['white', 'grey', 'black', 'yellow'].map((t) => (
//             <div 
//               key={t}
//               className="theme-trigger" 
//               onClick={() => setActiveTheme(t)} 
//               style={{ 
//                 width: '20px', 
//                 height: '20px', 
//                 borderRadius: '50%', 
//                 backgroundColor: t === 'white' ? '#fff' : t === 'grey' ? '#2c2c2e' : t === 'black' ? '#000' : '#ffcc00', 
//                 border: `2px solid ${activeTheme === t ? '#ffcc00' : '#000'}`, 
//                 cursor: 'pointer' 
//               }} 
//             />
//           ))}
//         </div>

//         <nav style={styles.navBar}>
//           {['home', 'about', 'business', 'gallery', 'contact'].map((tab) => (
//             <button key={tab} style={styles.navButton(activeTab === tab)} onClick={() => setActiveTab(tab)}>
//               {tab}
//             </button>
//           ))}
//         </nav>
//       </div>

//       <div style={styles.bentoLayout}>
//         <div style={{...styles.cell(12, 1, 'transparent'), padding: '0', border: 'none', justifyContent: 'center'}}>
//           <div style={styles.marqueeWrapper}>
//             <div style={styles.marqueeText}>
//               ASHISH MORE • ARIES SIGN • ASHIRWAD VILLA • A17 WATER CHANNELS • BRAND MATRIX TRANSMISSION •&nbsp;
//             </div>
//           </div>
//         </div>

//         {/* HOME VIEWPORT */}
//         {activeTab === 'home' && (
//           <div style={{ ...styles.cell(12, 4, 'transparent'), border: 'none', alignItems: 'center', justifyContent: 'center', textAlign: 'center', minHeight: isMobile ? '45vh' : '58vh' }} className="animated-grid-cell">
//             <img src="https://unsplash.com" alt="Ashish More" style={styles.avatar} />
//             <h1 style={{ fontSize: isMobile ? '3rem' : '5.5rem', fontWeight: '900', letterSpacing: '-1.5px', textTransform: 'uppercase', margin: '15px 0 10px 0', lineHeight: 1 }}>
//               Ashish More
//             </h1>
//             <p style={{ color: activePalette.muted, fontSize: isMobile ? '1.05rem' : '1.25rem', maxWidth: '600px', margin: '0 auto 20px auto', lineHeight: '1.5' }}>
//               Blending minimalist structures, spatial property management assets, and fluid filtration product operations.
//             </p>
//             <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', background: activePalette.surface, padding: '10px 20px', borderRadius: '30px', border: `1px solid ${activePalette.border}` }}>
//               <span style={{ fontSize: '0.85rem', fontFamily: 'monospace', fontWeight: '700' }}>CLOCK: {currentTime}</span>
//             </div>
//           </div>
//         )}

//         {/* ABOUT VIEWPORT: COSMIC CONFIGURATION INTEGRATING TIMELINE DATA */}
//         {activeTab === 'about' && (
//           <div style={styles.cell(12, 3)} className="animated-grid-cell">
//             <div style={styles.zodiacGraphic}>♈</div>
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', color: activePalette.text, textTransform: 'uppercase' }}>COSMIC CONFIGURATION</span>
//               <h2 style={{ fontSize: isMobile ? '1.8rem' : '2.8rem', fontWeight: '900', textTransform: 'uppercase', margin: '4px 0 20px 0' }}>Zodiac Archetype: Aries</h2>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', zIndex: 5 }}>
//               <p style={{ color: activePalette.muted, fontSize: '1rem', lineHeight: '1.6', margin: 0 }}>
//                 Governed by Mars, the Aries fire signature forms the baseline of my operation style: highly dynamic execution vectors, absolute courage in structural implementations, and a natural instinct to pioneer new project layers.
//               </p>
//               <div style={{ padding: '20px', backgroundColor: activePalette.bg, borderRadius: '20px', border: `1px solid ${activePalette.border}`, display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                 <div>
//                   <span style={{ fontSize: '0.7rem', fontWeight: '800', color: activePalette.muted, display: 'block', marginBottom: '2px', letterSpacing: '0.5px' }}>CHRONOLOGICAL METADATA</span>
//                   <div style={{ fontSize: '0.95rem', fontWeight: '800', letterSpacing: '0.2px' }}>
//                     17 June 2001 // 08:05 AM
//                   </div>
//                 </div>
//                 <div>
//                   <span style={{ fontSize: '0.7rem', fontWeight: '800', color: activePalette.muted, display: 'block', marginBottom: '2px', letterSpacing: '0.5px' }}>ASTROLOGICAL PARAMETERS</span>
//                   <div style={{ fontSize: '0.85rem', lineHeight: '1.6', fontWeight: '600' }}>
//                     • Quadruplicity: Cardinal Force | Element: Fire<br />
//                     • Core Vision: Independent Momentum, Bold Focus
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* BUSINESS VIEWPORT */}
//         {activeTab === 'business' && (
//           <div style={styles.cell(12, 4)} className="animated-grid-cell">
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', textTransform: 'uppercase' }}>ENTERPRISE DIRECTORY NODES</span>
//               <h2 style={{ fontSize: isMobile ? '1.8rem' : '2.8rem', fontWeight: '900', textTransform: 'uppercase', margin: '4px 0 15px 0' }}>Live Asset Operations</h2>
//             </div>

//             <div style={styles.businessGrid}>
//               <a href="https://instagram.com" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.businessCard}>
//                 <div>
//                   <h3 style={{ fontSize: '1.4rem', fontWeight: '900', margin: '0 0 8px 0', textTransform: 'uppercase' }}>Ashirwad Villa</h3>
//                   <p style={{ color: activePalette.muted, fontSize: '0.85rem', lineHeight: '1.5', margin: 0 }}>
//                     Luxury escape destination hub. Access current pricing structures, check live seasonal calendars, review blueprints, and confirm booking protocols directly.
//                   </p>
//                 </div>
//                 <span style={{ fontWeight: '800', fontSize: '0.8rem', textTransform: 'uppercase', marginTop: '10px' }}>Open Booking Gateway ↗</span>
//               </a>

//               <a href="https://github.io" target="_blank" rel="noreferrer" className="interactive-btn" style={styles.businessCard}>
//                 <div>
//                   <h3 style={{ fontSize: '1.4rem', fontWeight: '900', margin: '0 0 8px 0', textTransform: 'uppercase' }}>A17 Fluid Infrastructure</h3>
//                   <p style={{ color: activePalette.muted, fontSize: '0.85rem', lineHeight: '1.5', margin: 0 }}>
//                     High-performance algorithmic filtration web system deployment layer. Explore purification matrices, compliance tracking, and supply endpoints.
//                   </p>
//                 </div>
//                 <span style={{ fontWeight: '800', fontSize: '0.8rem', textTransform: 'uppercase', marginTop: '10px' }}>Verify A17 Network Link ↗</span>
//               </a>
//             </div>
//           </div>
//         )}

//         {/* GALLERY VIEWPORT */}
//         {activeTab === 'gallery' && (
//           <div style={styles.cell(12, 3)} className="animated-grid-cell">
//             <div>
//               <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '2px', textTransform: 'uppercase' }}>CAPTURED RECORDS // MEDIA STORAGE</span>
//               <h2 style={{ fontSize: isMobile ? '1.8rem' : '2.5rem', fontWeight: '900', textTransform: 'uppercase', margin: '4px 0 20px 0' }}>Photo Vault Gallery</h2>
//             </div>
//             <div style={styles.galleryGrid}>
//               {bentoGallery.map((url, idx) => (
//                 <div key={idx} style={{ overflow: 'hidden', borderRadius: '14px', height: isMobile ? '100px' : '140px', border: `1px solid ${activePalette.border}` }}>
//                   <img src={url} alt={`Asset Container ${idx}`} className="media-vault-img" style={{ width: '100%', height: '100%', objectFit: 'cover', cursor: 'zoom-in' }} onClick={() => setSelectedPhoto(url)} />
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* CONTACT VIEWPORT */}
//         {activeTab === 'contact' && (
//           <>
//             <div style={styles.cell(4, 3)} className="animated-grid-cell">
//               <div>
//                 <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '1px', color: activePalette.muted, textTransform: 'uppercase' }}>DEVICE SYNC ENGINE</span>
//                 <h3 style={{ fontSize: '1.5rem', fontWeight: '900', margin: '5px 0 8px 0', textTransform: 'uppercase' }}>Save Address</h3>
//                 <p style={{ color: activePalette.muted, fontSize: '0.85rem', lineHeight: '1.5', margin: 0 }}>
//                   Automatically synchronize Ashish More's contact card parameters straight to your mobile manager database.
//                 </p>
//               </div>
//               <button onClick={downloadVCard} className="interactive-btn" style={styles.vcardBtn}>
//                 Save Contact VCF ↓
//               </button>
//             </div>

//             <div style={styles.cell(8, 3)} className="animated-grid-cell">
//               <div>
//                 <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '1px', color: activePalette.muted, textTransform: 'uppercase' }}>COMMUNICATIONS TERMINAL</span>
//                 <h3 style={{ fontSize: '1.5rem', fontWeight: '900', margin: '5px 0 5px 0', textTransform: 'uppercase' }}>Social Matrix Nodes</h3>
//               </div>

//               <div className="social-honeycomb-grid">
//                 {['snapchat', 'instagram', 'facebook', 'twitter', 'github', 'pinterest'].map((brand) => (
//                   <a key={brand} href={`https://${brand}.com`} target="_blank" rel="noreferrer" className={`cyber-social-node ${brand}-node`}>
//                     <div className="node-bg-wave" />
//                     <span className="node-label">{brand} //</span>
//                   </a>
//                 ))}
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }



// import React from 'react';

// export default function Portfolio() {
//   // --- USER PROFILE DATA ---
//   const profile = {
//     name: "Ar. Shreya Thakare", // Replace with your name
//     title: "Founder & Creative Director",
//     phone: "+91 93590 09527",
//     email: "hello@stinteriorstudio.com",
//     address: "Main Baner-Sus Road, Complex Block B, Sus, Pune, Maharashtra 411021, India",
//     image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=600", // Replace with your profile image URL
//     bio: "Crafting bespoke luxury environments that balance timeless aesthetics with functional structural design. Turning raw structural vectors into extensions of personal lifestyle."
//   };

//   // --- THEME COLORS (ST Interior Studio Specs) ---
//   const colors = {
//     bgLight: "#FFFFFF",
//     bgDark: "#0B0B0B",
//     textPrimary: "#111111",
//     textMuted: "#666666",
//     accentGold: "#B89D70", // Subtle luxury accent color
//     border: "#EAEAEA"
//   };

//   // --- DOWNLOAD CONTACT FUNCTION (Generates standard .vcf file) ---
//   const handleDownloadContact = () => {
//     const vcardData = [
//       "BEGIN:VCARD",
//       "VERSION:3.0",
//       `FN:${profile.name}`,
//       `TITLE:${profile.title}`,
//       `TEL;TYPE=CELL:${profile.phone}`,
//       `EMAIL;TYPE=INTERNET:${profile.email}`,
//       `ADR;TYPE=WORK:;;${profile.address}`,
//       "END:VCARD"
//     ].join("\n");

//     const blob = new Blob([vcardData], { type: "text/vcard;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", `${profile.name.replace(/\s+/g, '_')}_contact.vcf`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // --- INLINE STYLES ---
//   const styles = {
//     container: {
//       fontFamily: "'Playfair Display', 'Helvetica Neue', Arial, sans-serif",
//       backgroundColor: colors.bgLight,
//       color: colors.textPrimary,
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: "40px 20px",
//       letterSpacing: "0.5px"
//     },
//     card: {
//       backgroundColor: colors.bgLight,
//       border: `1px solid ${colors.border}`,
//       maxWidth: "850px",
//       width: "100%",
//       display: "flex",
//       flexDirection: "row",
//       flexWrap: "wrap",
//       boxShadow: "0 20px 40px rgba(0,0,0,0.03)",
//       overflow: "hidden"
//     },
//     imageSection: {
//       flex: "1 1 350px",
//       position: "relative",
//       minHeight: "400px",
//       backgroundColor: colors.bgDark
//     },
//     profileImg: {
//       width: "100%",
//       height: "100%",
//       objectFit: "cover",
//       display: "block"
//     },
//     infoSection: {
//       flex: "1 1 450px",
//       padding: "60px 50px",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center"
//     },
//     logoText: {
//       fontSize: "14px",
//       fontWeight: "700",
//       letterSpacing: "4px",
//       textTransform: "uppercase",
//       color: colors.textPrimary,
//       marginBottom: "30px",
//       borderBottom: `1px solid ${colors.border}`,
//       paddingBottom: "10px",
//       width: "fit-content"
//     },
//     name: {
//       fontSize: "36px",
//       fontWeight: "400",
//       margin: "0 0 5px 0",
//       color: colors.textPrimary
//     },
//     title: {
//       fontSize: "13px",
//       textTransform: "uppercase",
//       letterSpacing: "2px",
//       color: colors.textMuted,
//       marginBottom: "25px",
//       fontWeight: "500"
//     },
//     bio: {
//       fontSize: "15px",
//       lineHeight: "1.8",
//       color: colors.textMuted,
//       marginBottom: "35px"
//     },
//     detailsGrid: {
//       borderTop: `1px solid ${colors.border}`,
//       paddingTop: "25px",
//       marginBottom: "40px"
//     },
//     detailRow: {
//       display: "flex",
//       marginBottom: "15px",
//       fontSize: "14px",
//       lineHeight: "1.6"
//     },
//     label: {
//       width: "90px",
//       fontWeight: "600",
//       textTransform: "uppercase",
//       fontSize: "11px",
//       letterSpacing: "1px",
//       color: colors.textPrimary,
//       marginTop: "3px"
//     },
//     value: {
//       flex: "1",
//       color: colors.textMuted
//     },
//     btn: {
//       backgroundColor: colors.bgDark,
//       color: colors.bgLight,
//       border: "none",
//       padding: "15px 30px",
//       fontSize: "12px",
//       textTransform: "uppercase",
//       letterSpacing: "2px",
//       fontWeight: "600",
//       cursor: "pointer",
//       transition: "all 0.3s ease",
//       width: "fit-content",
//       boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
//     }
//   };

//   return (
//     <div style={styles.container}>
//       {/* Portfolio Card Wrapper */}
//       <div style={styles.card}>

//         {/* Left Side: Profile Image */}
//         <div style={styles.imageSection}>
//           <img
//             src={profile.image}
//             alt={profile.name}
//             style={styles.profileImg}
//           />
//         </div>

//         {/* Right Side: Identity & Contact Information */}
//         <div style={styles.infoSection}>
//           <div style={styles.logoText}>ST STUDIO PORTFOLIO</div>

//           <h1 style={styles.name}>{profile.name}</h1>
//           <div style={styles.title}>{profile.title}</div>

//           <p style={styles.bio}>{profile.bio}</p>

//           {/* Detailed Specifications */}
//           <div style={styles.detailsGrid}>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>Phone</span>
//               <span style={styles.value}>{profile.phone}</span>
//             </div>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>Email</span>
//               <span style={styles.value}>{profile.email}</span>
//             </div>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>Address</span>
//               <span style={styles.value}>{profile.address}</span>
//             </div>
//           </div>

//           {/* Action Trigger */}
//           <button
//             onClick={handleDownloadContact}
//             style={styles.btn}
//             onMouseEnter={(e) => {
//               e.target.style.backgroundColor = colors.accentGold;
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.backgroundColor = colors.bgDark;
//             }}
//           >
//             Download Contact Card
//           </button>
//         </div>

//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect } from 'react';

// export default function LuxuryPortfolio() {
//   // --- USER PROFILE DATA ---
//   const profile = {
//     name: "Ar. Shreya Thakare",
//     title: "Founder & Creative Director",
//     phone: "+91 93590 09527",
//     email: "hello@stinteriorstudio.com",
//     address: "Main Baner-Sus Road, Complex Block B, Sus, Pune, Maharashtra 411021, India",
//     image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=800",
//     bio: "Crafting bespoke luxury environments that balance timeless aesthetics with functional structural design. We don't simply style rooms; we redesign human movement parameters."
//   };

//   // --- BRANDING COLORS ---
//   const colors = {
//     bgLight: "#FFFFFF",
//     bgDark: "#0B0B0B",
//     textPrimary: "#111111",
//     textMuted: "#777777",
//     accentGold: "#B89D70",
//     border: "#E5E5E5",
//     lineOverlay: "rgba(184, 157, 112, 0.15)"
//   };

//   // --- RESPONSIVE STATE ---
//   const [isMobile, setIsMobile] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const [domLoaded, setDomLoaded] = useState(false);

//   useEffect(() => {
//     setDomLoaded(true);
//     const handleResize = () => {
//       setIsWindowMobile();
//     };

//     const setIsWindowMobile = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };

//     setIsWindowMobile();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // --- DYNAMIC VCARD GENERATION ---
//   const handleDownloadContact = () => {
//     const vcardData = [
//       "BEGIN:VCARD",
//       "VERSION:3.0",
//       `FN:${profile.name}`,
//       `TITLE:${profile.title}`,
//       `TEL;TYPE=CELL:${profile.phone}`,
//       `EMAIL;TYPE=INTERNET:${profile.email}`,
//       `ADR;TYPE=WORK:;;${profile.address}`,
//       "END:VCARD"
//     ].join("\n");

//     const blob = new Blob([vcardData], { type: "text/vcard;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", `${profile.name.replace(/\s+/g, '_')}_contact.vcf`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // --- STRUCTURAL INLINE STYLES ---
//   const styles = {
//     container: {
//       fontFamily: "'Playfair Display', 'Helvetica Neue', Arial, sans-serif",
//       backgroundColor: colors.bgLight,
//       color: colors.textPrimary,
//       minHeight: "100vh",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: isMobile ? "20px 15px" : "60px 40px",
//       overflowX: "hidden",
//       position: "relative"
//     },
//     // Background Fine-Line Architecture Accent
//     bgLine: {
//       position: "absolute",
//       top: 0,
//       left: "33%",
//       width: "1px",
//       height: "100%",
//       backgroundColor: colors.lineOverlay,
//       zIndex: 1,
//       display: isMobile ? "none" : "block"
//     },
//     workspace: {
//       position: "relative",
//       zIndex: 2,
//       maxWidth: "1100px",
//       width: "100%",
//       display: "flex",
//       flexDirection: isMobile ? "column" : "row",
//       alignItems: "center",
//       gap: isMobile ? "40px" : "0px"
//     },
//     // Visual Canvas Block (Asymmetric & Animated Entry)
//     imageWrapper: {
//       flex: isMobile ? "1 1 100%" : "0 0 45%",
//       width: "100%",
//       position: "relative",
//       transform: domLoaded ? "translateX(0)" : "translateX(-50px)",
//       opacity: domLoaded ? 1 : 0,
//       transition: "transform 1.2s cubic-bezier(0.16, 1, 0.3, 1), opacity 1.2s ease",
//       zIndex: 4
//     },
//     imageContainer: {
//       width: "100%",
//       paddingBottom: "125%", // Architectural vertical ratio
//       position: "relative",
//       overflow: "hidden",
//       boxShadow: "0 30px 60px rgba(0,0,0,0.08)"
//     },
//     profileImg: {
//       position: "absolute",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       objectFit: "cover",
//       transform: isHovered ? "scale(1.04)" : "scale(1)",
//       transition: "transform 1.5s cubic-bezier(0.16, 1, 0.3, 1)"
//     },
//     // Decorative Framing Line
//     imgBorderAccent: {
//       position: "absolute",
//       top: "15px",
//       left: "15px",
//       right: "15px",
//       bottom: "15px",
//       border: `1px solid ${colors.bgLight}`,
//       pointerEvents: "none",
//       zIndex: 2,
//       opacity: isHovered ? 0.8 : 0.4,
//       transition: "opacity 0.6s ease"
//     },
//     // Text Canvas Block (Overlapping & Animated Entry)
//     contentWrapper: {
//       flex: isMobile ? "1 1 100%" : "0 0 60%",
//       width: "100%",
//       backgroundColor: colors.bgLight,
//       padding: isMobile ? "30px 20px" : "60px 60px 60px 80px",
//       marginLeft: isMobile ? "0px" : "-10%", // Asymmetric overlapping vector
//       boxShadow: isMobile ? "none" : "20px 30px 60px rgba(0,0,0,0.04)",
//       border: isMobile ? "none" : `1px solid ${colors.border}`,
//       position: "relative",
//       zIndex: 5,
//       transform: domLoaded ? "translateX(0)" : "translateX(50px)",
//       opacity: domLoaded ? 1 : 0,
//       transition: "transform 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.2s, opacity 1.2s ease 0.2s"
//     },
//     studioTag: {
//       fontSize: "11px",
//       fontWeight: "700",
//       letterSpacing: "5px",
//       textTransform: "uppercase",
//       color: colors.accentGold,
//       marginBottom: "20px",
//       display: "block"
//     },
//     name: {
//       fontSize: isMobile ? "32px" : "44px",
//       fontFamily: "'Playfair Display', serif",
//       fontWeight: "400",
//       lineHeight: "1.2",
//       margin: "0 0 10px 0",
//       color: colors.textPrimary
//     },
//     title: {
//       fontSize: "12px",
//       textTransform: "uppercase",
//       letterSpacing: "3px",
//       color: colors.textMuted,
//       marginBottom: "30px",
//       fontWeight: "500",
//       display: "block"
//     },
//     bio: {
//       fontSize: "15px",
//       lineHeight: "1.8",
//       color: colors.textMuted,
//       marginBottom: "40px",
//       fontWeight: "300"
//     },
//     detailsSection: {
//       borderTop: `1px solid ${colors.border}`,
//       paddingTop: "30px",
//       marginBottom: "40px"
//     },
//     detailRow: {
//       display: "flex",
//       flexDirection: isMobile ? "column" : "row",
//       marginBottom: "20px",
//       fontSize: "14px"
//     },
//     label: {
//       width: isMobile ? "100%" : "120px",
//       fontWeight: "600",
//       textTransform: "uppercase",
//       fontSize: "11px",
//       letterSpacing: "1.5px",
//       color: colors.textPrimary,
//       marginBottom: isMobile ? "4px" : "0px"
//     },
//     value: {
//       flex: "1",
//       color: colors.textMuted,
//       lineHeight: "1.6"
//     },
//     // Interactive CTA Button Animation Configuration
//     btnWrapper: {
//       position: "relative",
//       display: "inline-block",
//       overflow: "hidden"
//     },
//     btn: {
//       backgroundColor: colors.bgDark,
//       color: colors.bgLight,
//       border: `1px solid ${colors.bgDark}`,
//       padding: "18px 36px",
//       fontSize: "11px",
//       textTransform: "uppercase",
//       letterSpacing: "3px",
//       fontWeight: "600",
//       cursor: "pointer",
//       position: "relative",
//       zIndex: 2,
//       transition: "color 0.4s ease, background-color 0.4s ease",
//       width: isMobile ? "100%" : "auto"
//     }
//   };

//   return (
//     <div style={styles.container}>
//       {/* Structural Minimal Line Graphic */}
//       <div style={styles.bgLine} />

//       <div style={styles.workspace}>

//         {/* Asymmetric Image Layer */}
//         <div
//           style={styles.imageWrapper}
//           onMouseEnter={() => setIsHovered(true)}
//           onMouseLeave={() => setIsHovered(false)}
//         >
//           <div style={styles.imageContainer}>
//             <div style={styles.imgBorderAccent} />
//             <img
//               src={profile.image}
//               alt={profile.name}
//               style={styles.profileImg}
//             />
//           </div>
//         </div>

//         {/* Floating Portfolio Content Layer */}
//         <div style={styles.contentWrapper}>
//           <span style={styles.studioTag}>ST STUDIO // DESIGNER</span>

//           <h1 style={styles.name}>{profile.name}</h1>
//           <span style={styles.title}>{profile.title}</span>

//           <p style={styles.bio}>{profile.bio}</p>

//           {/* Spatial Blueprint Info Fields */}
//           <div style={styles.detailsSection}>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>Direct Line</span>
//               <span style={styles.value}>{profile.phone}</span>
//             </div>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>Electronic Mail</span>
//               <span style={styles.value}>{profile.email}</span>
//             </div>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>Headquarters</span>
//               <span style={styles.value}>{profile.address}</span>
//             </div>
//           </div>

//           {/* Core Interactive Action */}
//           <div style={styles.btnWrapper}>
//             <button
//               onClick={handleDownloadContact}
//               style={styles.btn}
//               onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = colors.bgLight;
//                 e.target.style.color = colors.textPrimary;
//                 e.target.style.border = `1px solid ${colors.textPrimary}`;
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.backgroundColor = colors.bgDark;
//                 e.target.style.color = colors.bgLight;
//                 e.target.style.border = `1px solid ${colors.bgDark}`;
//               }}
//             >
//               Download Contact Card
//             </button>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }


// import React, { useState, useEffect } from 'react';

// export default function LuxuryPortfolio() {
//   const [isMobile, setIsMobile] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const [btnHover, setBtnHover] = useState(false);
//   const [downloadSuccess, setDownloadSuccess] = useState(false);
//   const [activeSocial, setActiveSocial] = useState(null);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 868);
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const profile = {
//     name: "Ar. Shreya Thakare",
//     title: "Founder & Creative Director",
//     phone: "+91 93590 09527",
//     email: "hello@stinteriorstudio.com",
//     address: "Main Baner-Sus Road, Complex Block B, Sus, Pune, Maharashtra 411021, India",
//     image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=800", 
//     bio: "We don't simply style rooms; we redesign human movement parameters. By calculating raw architectural vectors, balancing natural luminosity, and layering custom bespoke organic textures, we generate spaces that function as quiet extensions of your subconscious state.",
//     socials: [
//       { id: 'insta', label: 'Instagram', url: 'https://www.instagram.com/', svg: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg> },
//       { id: 'fb', label: 'Facebook', url: 'https://www.facebook.com/', svg: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg> },
//       { id: 'pin', label: 'Pinterest', url: 'https://www.pinterest.com/', svg: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2C6.48 2 2 6.48 2 12c0 4.23 2.62 7.85 6.36 9.31-.09-.79-.17-2 .03-2.86.19-.78 1.23-5.22 1.23-5.22s-.31-.63-.31-1.56c0-1.46.85-2.55 1.9-2.55.9 0 1.33.67 1.33 1.48 0 .9-.57 2.25-.87 3.5-.25 1.05.52 1.91 1.55 1.91 1.86 0 3.29-1.96 3.29-4.79 0-2.5-1.8-4.25-4.36-4.25-2.97 0-4.71 2.23-4.71 4.53 0 .9.35 1.87.78 2.39.09.1.1.19.07.31-.08.33-.26 1.05-.3 1.2-.05.21-.17.25-.39.15-1.48-.69-2.41-2.86-2.41-4.6 0-3.75 2.73-7.2 7.86-7.2 4.13 0 7.34 2.94 7.34 6.88 0 4.1-2.59 7.4-6.18 7.4-1.21 0-2.34-.63-2.73-1.37l-.74 2.84c-.27 1.04-1 2.34-1.49 3.14C10.53 21.78 11.25 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z" fill="currentColor"/></svg> }
//     ]
//   };

//   const colors = {
//     background: '#F8F6F2',
//     surface: '#FFFFFF',
//     accent: '#D4AF37',
//     checkColor: '#4BB543',
//     textMain: '#2C302E',
//     textMuted: '#7A827E',
//     border: 'rgba(44, 48, 46, 0.08)'
//   };

//   const handleDownloadContact = () => {
//     const vcardData = [
//       "BEGIN:VCARD",
//       "VERSION:3.0",
//       `FN:${profile.name}`,
//       `TITLE:${profile.title}`,
//       `TEL;TYPE=CELL:${profile.phone}`,
//       `EMAIL;TYPE=INTERNET:${profile.email}`,
//       `ADR;TYPE=WORK:;;${profile.address}`,
//       "END:VCARD"
//     ].join("\n");

//     const blob = new Blob([vcardData], { type: "text/vcard;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", `${profile.name.replace(/\s+/g, '_')}_contact.vcf`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     setDownloadSuccess(true);
//     setTimeout(() => setDownloadSuccess(false), 2000);
//   };

//   useEffect(() => {
//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = `
//       @keyframes floatUp {
//         0% { opacity: 0; transform: translateY(40px); }
//         100% { opacity: 1; transform: translateY(0); }
//       }
//       @keyframes slowPan {
//         0% { transform: scale(1.15); filter: sepia(0.2); }
//         100% { transform: scale(1.02); filter: sepia(0); }
//       }
//       @keyframes lineReveal {
//         0% { width: 0; }
//         100% { width: 100%; }
//       }
//     `;
//     document.head.appendChild(styleSheet);
//     return () => { document.head.removeChild(styleSheet); };
//   }, []);

//   const styles = {
//     wrapper: {
//       fontFamily: "'Playfair Display', 'Helvetica Neue', sans-serif",
//       backgroundColor: colors.background,
//       color: colors.textMain,
//       minHeight: "100vh",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: isMobile ? "20px" : "40px",
//       boxSizing: "border-box",
//       overflowX: "hidden"
//     },
//     canvas: {
//       backgroundColor: colors.surface,
//       border: `1px solid ${colors.border}`,
//       width: "100%",
//       maxWidth: "1140px",
//       display: "flex",
//       flexDirection: isMobile ? "column" : "row",
//       boxShadow: "0 40px 90px rgba(44, 48, 46, 0.06)",
//       position: "relative",
//       animation: "floatUp 1.4s cubic-bezier(0.16, 1, 0.3, 1) forwards"
//     },
//     imagePane: {
//       flex: isMobile ? "0 0 420px" : "1 1 48%",
//       position: "relative",
//       overflow: "hidden",
//       backgroundColor: colors.textMain,
//       minHeight: isMobile ? "380px" : "630px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center"
//     },
//     imgElement: {
//       width: "100%",
//       height: "100%",
//       objectFit: "cover",
//       transition: "all 2s cubic-bezier(0.16, 1, 0.3, 1)",
//       animation: "slowPan 2.2s cubic-bezier(0.16, 1, 0.3, 1) forwards"
//     },
//     imageOverlay: {
//       position: "absolute",
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       background: "linear-gradient(to bottom, rgba(44,48,46,0.02) 0%, rgba(44,48,46,0.35) 100%)",
//       pointerEvents: "none"
//     },
//     contentPane: {
//       flex: isMobile ? "1 1 auto" : "1 1 52%",
//       padding: isMobile ? "45px 24px" : "60px 80px",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "space-between",
//       position: "relative"
//     },
//     branding: {
//       fontSize: "11px",
//       fontWeight: "700",
//       letterSpacing: "6px",
//       textTransform: "uppercase",
//       color: colors.accent,
//       marginBottom: "20px",
//       display: "block"
//     },
//     name: {
//       fontSize: isMobile ? "34px" : "46px",
//       fontWeight: "300",
//       letterSpacing: "-0.5px",
//       margin: "0 0 12px 0",
//       lineHeight: "1.15",
//       color: colors.textMain
//     },
//     role: {
//       fontSize: "12px",
//       textTransform: "uppercase",
//       letterSpacing: "3px",
//       color: colors.textMuted,
//       marginBottom: "25px",
//       fontWeight: "600",
//       display: "flex",
//       alignItems: "center",
//       gap: "12px"
//     },
//     roleLine: {
//       height: "1px",
//       backgroundColor: colors.border,
//       flexGrow: 1,
//       animation: "lineReveal 1.8s cubic-bezier(0.16, 1, 0.3, 1) forwards"
//     },
//     description: {
//       fontSize: "14.5px",
//       lineHeight: "1.8",
//       color: colors.textMuted,
//       marginBottom: "35px",
//       fontWeight: "300"
//     },
//     metaBlock: {
//       borderTop: `1px solid ${colors.border}`,
//       paddingTop: "30px",
//       marginBottom: "35px"
//     },
//     metaRow: {
//       display: "flex",
//       flexDirection: isMobile ? "column" : "row",
//       marginBottom: "18px",
//       fontSize: "13.5px",
//       lineHeight: "1.6"
//     },
//     metaLabel: {
//       width: isMobile ? "100%" : "140px",
//       fontWeight: "600",
//       textTransform: "uppercase",
//       fontSize: "10px",
//       letterSpacing: "2.5px",
//       color: colors.textMain,
//       marginBottom: isMobile ? "4px" : "0"
//     },
//     metaValueLink: {
//       flex: 1,
//       color: colors.textMuted,
//       fontWeight: "300",
//       textDecoration: "none",
//       transition: "color 0.3s ease",
//       cursor: "pointer"
//     },
//     socialContainer: {
//       display: "flex",
//       gap: "25px",
//       marginBottom: "35px",
//       alignItems: "center"
//     },
//     socialLink: (id) => ({
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       color: activeSocial === id ? colors.accent : colors.textMain,
//       transform: activeSocial === id ? "translateY(-3px)" : "translateY(0)",
//       transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
//       textDecoration: "none"
//     }),
//     buttonContainer: {
//       position: "relative",
//       display: "inline-block",
//       width: isMobile ? "100%" : "auto"
//     },
//     downloadBtn: {
//       backgroundColor: downloadSuccess 
//         ? colors.checkColor 
//         : (btnHover ? colors.accent : colors.textMain),
//       color: colors.surface,
//       border: "none",
//       padding: "18px 40px",
//       fontSize: "11px",
//       textTransform: "uppercase",
//       letterSpacing: "3px",
//       fontWeight: "600",
//       cursor: "pointer",
//       width: isMobile ? "100%" : "auto",
//       transition: "all 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
//       transform: btnHover && !downloadSuccess ? "translateY(-4px)" : "none",
//       boxShadow: downloadSuccess 
//         ? `0 12px 25px rgba(75, 181, 67, 0.3)` 
//         : (btnHover ? `0 15px 30px rgba(212, 175, 55, 0.25)` : "none")
//     }
//   };

//   return (
//     <div style={styles.wrapper}>
//       <div style={styles.canvas}>
        
//         <div style={styles.imagePane}>
//           <img 
//             src={profile.image} 
//             alt={profile.name} 
//             style={{
//               ...styles.imgElement,
//               transform: isHovered ? "scale(1.06)" : "scale(1)"
//             }}
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//           />
//           <div style={styles.imageOverlay} />
//         </div>

//         <div style={styles.contentPane}>
//           <div>
//             <span style={styles.branding}>ST Studio Showcase</span>
//             <h1 style={styles.name}>{profile.name}</h1>
//             <div style={styles.role}>
//               <span>{profile.title}</span>
//               <div style={styles.roleLine} />
//             </div>
            
//             <p style={styles.description}>{profile.bio}</p>
//           </div>

//           <div>
//             {/* Interactive Contact Anchors */}
//             <div style={styles.metaBlock}>
//               <div style={styles.metaRow}>
//                 <span style={styles.metaLabel}>Direct Line</span>
//                 <a 
//                   href={`tel:${profile.phone.replace(/\s+/g, '')}`} 
//                   style={styles.metaValueLink}
//                   onMouseEnter={(e) => e.target.style.color = colors.accent}
//                   onMouseLeave={(e) => e.target.style.color = colors.textMuted}
//                 >
//                   {profile.phone}
//                 </a>
//               </div>
//               <div style={styles.metaRow}>
//                 <span style={styles.metaLabel}>Electronic Mail</span>
//                 <a 
//                   href={`mailto:${profile.email}`} 
//                   style={styles.metaValueLink}
//                   onMouseEnter={(e) => e.target.style.color = colors.accent}
//                   onMouseLeave={(e) => e.target.style.color = colors.textMuted}
//                 >
//                   {profile.email}
//                 </a>
//               </div>
//               <div style={styles.metaRow}>
//                 <span style={styles.metaLabel}>Studio Base</span>
//                 <a 
//                   href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(profile.address)}`} 
//                   target="_blank" 
//                   rel="noopener noreferrer"
//                   style={styles.metaValueLink}
//                   onMouseEnter={(e) => e.target.style.color = colors.accent}
//                   onMouseLeave={(e) => e.target.style.color = colors.textMuted}
//                 >
//                   {profile.address}
//                 </a>
//               </div>
//             </div>

//             {/* Social Media Row with Micro-Animations */}
//             <div style={styles.socialContainer}>
//               {profile.socials.map((social) => (
//                 <a
//                   key={social.id}
//                   href={social.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   title={social.label}
//                   style={styles.socialLink(social.id)}
//                   onMouseEnter={() => setActiveSocial(social.id)}
//                   onMouseLeave={() => setActiveSocial(null)}
//                 >
//                   {social.svg}
//                 </a>
//               ))}
//             </div>

//             <div style={styles.buttonContainer}>
//               <button
//                 onClick={handleDownloadContact}
//                 onMouseEnter={() => setBtnHover(true)}
//                 onMouseLeave={() => setBtnHover(false)}
//                 style={styles.downloadBtn}
//               >
//                 {downloadSuccess ? "✓ Card Saved" : "Incorporate Contact Card"}
//               </button>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }